import * as It from "vue";
import { computed as P, ref as O, shallowRef as Qt, watch as U, getCurrentScope as Zt, onScopeDispose as en, shallowReadonly as $e, unref as p, defineComponent as B, Comment as Nn, mergeProps as z, cloneVNode as Fn, h as Se, toRefs as Qe, getCurrentInstance as Ee, openBlock as w, createBlock as k, withCtx as E, renderSlot as S, withKeys as Ln, reactive as Ze, watchEffect as ee, markRaw as Vn, createTextVNode as Q, normalizeProps as tn, guardReactiveProps as nn, toDisplayString as J, onMounted as Me, resolveDynamicComponent as zn, createVNode as R, effectScope as on, nextTick as Pe, Fragment as ue, onUnmounted as bt, createCommentVNode as j, Teleport as Wn, withModifiers as Nt, inject as Hn, provide as jn, toHandlerKey as Un, camelize as an, toRef as Kn, onBeforeUnmount as qn, normalizeStyle as ae, mergeDefaults as Yn, watchPostEffect as Xn, createElementBlock as _, readonly as Jn, normalizeClass as M, createElementVNode as q, renderList as Ce, Transition as Gn, withDirectives as Ye, vShow as ft, mergeModels as Ft, useModel as Qn, vModelText as Zn, useCssVars as eo } from "vue";
const to = ["top", "right", "bottom", "left"], ye = Math.min, X = Math.max, Xe = Math.round, He = Math.floor, le = (e) => ({
  x: e,
  y: e
}), no = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, oo = {
  start: "end",
  end: "start"
};
function pt(e, t, n) {
  return X(e, ye(t, n));
}
function de(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ce(e) {
  return e.split("-")[0];
}
function _e(e) {
  return e.split("-")[1];
}
function wt(e) {
  return e === "x" ? "y" : "x";
}
function xt(e) {
  return e === "y" ? "height" : "width";
}
function be(e) {
  return ["top", "bottom"].includes(ce(e)) ? "y" : "x";
}
function Ct(e) {
  return wt(be(e));
}
function ao(e, t, n) {
  n === void 0 && (n = !1);
  const o = _e(e), a = Ct(e), l = xt(a);
  let i = a === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[l] > t.floating[l] && (i = Je(i)), [i, Je(i)];
}
function lo(e) {
  const t = Je(e);
  return [mt(e), t, mt(t)];
}
function mt(e) {
  return e.replace(/start|end/g, (t) => oo[t]);
}
function io(e, t, n) {
  const o = ["left", "right"], a = ["right", "left"], l = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? a : o : t ? o : a;
    case "left":
    case "right":
      return t ? l : i;
    default:
      return [];
  }
}
function ro(e, t, n, o) {
  const a = _e(e);
  let l = io(ce(e), n === "start", o);
  return a && (l = l.map((i) => i + "-" + a), t && (l = l.concat(l.map(mt)))), l;
}
function Je(e) {
  return e.replace(/left|right|bottom|top/g, (t) => no[t]);
}
function so(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function ln(e) {
  return typeof e != "number" ? so(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ge(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: a
  } = e;
  return {
    width: o,
    height: a,
    top: n,
    left: t,
    right: t + o,
    bottom: n + a,
    x: t,
    y: n
  };
}
function Lt(e, t, n) {
  let {
    reference: o,
    floating: a
  } = e;
  const l = be(t), i = Ct(t), s = xt(i), c = ce(t), d = l === "y", r = o.x + o.width / 2 - a.width / 2, u = o.y + o.height / 2 - a.height / 2, f = o[s] / 2 - a[s] / 2;
  let m;
  switch (c) {
    case "top":
      m = {
        x: r,
        y: o.y - a.height
      };
      break;
    case "bottom":
      m = {
        x: r,
        y: o.y + o.height
      };
      break;
    case "right":
      m = {
        x: o.x + o.width,
        y: u
      };
      break;
    case "left":
      m = {
        x: o.x - a.width,
        y: u
      };
      break;
    default:
      m = {
        x: o.x,
        y: o.y
      };
  }
  switch (_e(t)) {
    case "start":
      m[i] -= f * (n && d ? -1 : 1);
      break;
    case "end":
      m[i] += f * (n && d ? -1 : 1);
      break;
  }
  return m;
}
const uo = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: a = "absolute",
    middleware: l = [],
    platform: i
  } = n, s = l.filter(Boolean), c = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let d = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: r,
    y: u
  } = Lt(d, o, c), f = o, m = {}, v = 0;
  for (let y = 0; y < s.length; y++) {
    const {
      name: h,
      fn: b
    } = s[y], {
      x: A,
      y: g,
      data: x,
      reset: C
    } = await b({
      x: r,
      y: u,
      initialPlacement: o,
      placement: f,
      strategy: a,
      middlewareData: m,
      rects: d,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    r = A ?? r, u = g ?? u, m = {
      ...m,
      [h]: {
        ...m[h],
        ...x
      }
    }, C && v <= 50 && (v++, typeof C == "object" && (C.placement && (f = C.placement), C.rects && (d = C.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : C.rects), {
      x: r,
      y: u
    } = Lt(d, f, c)), y = -1);
  }
  return {
    x: r,
    y: u,
    placement: f,
    strategy: a,
    middlewareData: m
  };
};
async function Fe(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: a,
    platform: l,
    rects: i,
    elements: s,
    strategy: c
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: r = "viewport",
    elementContext: u = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = de(t, e), v = ln(m), h = s[f ? u === "floating" ? "reference" : "floating" : u], b = Ge(await l.getClippingRect({
    element: (n = await (l.isElement == null ? void 0 : l.isElement(h))) == null || n ? h : h.contextElement || await (l.getDocumentElement == null ? void 0 : l.getDocumentElement(s.floating)),
    boundary: d,
    rootBoundary: r,
    strategy: c
  })), A = u === "floating" ? {
    x: o,
    y: a,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, g = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(s.floating)), x = await (l.isElement == null ? void 0 : l.isElement(g)) ? await (l.getScale == null ? void 0 : l.getScale(g)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, C = Ge(l.convertOffsetParentRelativeRectToViewportRelativeRect ? await l.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: A,
    offsetParent: g,
    strategy: c
  }) : A);
  return {
    top: (b.top - C.top + v.top) / x.y,
    bottom: (C.bottom - b.bottom + v.bottom) / x.y,
    left: (b.left - C.left + v.left) / x.x,
    right: (C.right - b.right + v.right) / x.x
  };
}
const co = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: a,
      rects: l,
      platform: i,
      elements: s,
      middlewareData: c
    } = t, {
      element: d,
      padding: r = 0
    } = de(e, t) || {};
    if (d == null)
      return {};
    const u = ln(r), f = {
      x: n,
      y: o
    }, m = Ct(a), v = xt(m), y = await i.getDimensions(d), h = m === "y", b = h ? "top" : "left", A = h ? "bottom" : "right", g = h ? "clientHeight" : "clientWidth", x = l.reference[v] + l.reference[m] - f[m] - l.floating[v], C = f[m] - l.reference[m], D = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(d));
    let $ = D ? D[g] : 0;
    (!$ || !await (i.isElement == null ? void 0 : i.isElement(D))) && ($ = s.floating[g] || l.floating[v]);
    const N = x / 2 - C / 2, W = $ / 2 - y[v] / 2 - 1, T = ye(u[b], W), Z = ye(u[A], W), H = T, Y = $ - y[v] - Z, F = $ / 2 - y[v] / 2 + N, pe = pt(H, F, Y), K = !c.arrow && _e(a) != null && F !== pe && l.reference[v] / 2 - (F < H ? T : Z) - y[v] / 2 < 0, oe = K ? F < H ? F - H : F - Y : 0;
    return {
      [m]: f[m] + oe,
      data: {
        [m]: pe,
        centerOffset: F - pe - oe,
        ...K && {
          alignmentOffset: oe
        }
      },
      reset: K
    };
  }
}), fo = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: a,
        middlewareData: l,
        rects: i,
        initialPlacement: s,
        platform: c,
        elements: d
      } = t, {
        mainAxis: r = !0,
        crossAxis: u = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: y = !0,
        ...h
      } = de(e, t);
      if ((n = l.arrow) != null && n.alignmentOffset)
        return {};
      const b = ce(a), A = be(s), g = ce(s) === s, x = await (c.isRTL == null ? void 0 : c.isRTL(d.floating)), C = f || (g || !y ? [Je(s)] : lo(s)), D = v !== "none";
      !f && D && C.push(...ro(s, y, v, x));
      const $ = [s, ...C], N = await Fe(t, h), W = [];
      let T = ((o = l.flip) == null ? void 0 : o.overflows) || [];
      if (r && W.push(N[b]), u) {
        const F = ao(a, i, x);
        W.push(N[F[0]], N[F[1]]);
      }
      if (T = [...T, {
        placement: a,
        overflows: W
      }], !W.every((F) => F <= 0)) {
        var Z, H;
        const F = (((Z = l.flip) == null ? void 0 : Z.index) || 0) + 1, pe = $[F];
        if (pe)
          return {
            data: {
              index: F,
              overflows: T
            },
            reset: {
              placement: pe
            }
          };
        let K = (H = T.filter((oe) => oe.overflows[0] <= 0).sort((oe, me) => oe.overflows[1] - me.overflows[1])[0]) == null ? void 0 : H.placement;
        if (!K)
          switch (m) {
            case "bestFit": {
              var Y;
              const oe = (Y = T.filter((me) => {
                if (D) {
                  const ve = be(me.placement);
                  return ve === A || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ve === "y";
                }
                return !0;
              }).map((me) => [me.placement, me.overflows.filter((ve) => ve > 0).reduce((ve, In) => ve + In, 0)]).sort((me, ve) => me[1] - ve[1])[0]) == null ? void 0 : Y[0];
              oe && (K = oe);
              break;
            }
            case "initialPlacement":
              K = s;
              break;
          }
        if (a !== K)
          return {
            reset: {
              placement: K
            }
          };
      }
      return {};
    }
  };
};
function Vt(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function zt(e) {
  return to.some((t) => e[t] >= 0);
}
const po = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: o = "referenceHidden",
        ...a
      } = de(e, t);
      switch (o) {
        case "referenceHidden": {
          const l = await Fe(t, {
            ...a,
            elementContext: "reference"
          }), i = Vt(l, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: zt(i)
            }
          };
        }
        case "escaped": {
          const l = await Fe(t, {
            ...a,
            altBoundary: !0
          }), i = Vt(l, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: zt(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function mo(e, t) {
  const {
    placement: n,
    platform: o,
    elements: a
  } = e, l = await (o.isRTL == null ? void 0 : o.isRTL(a.floating)), i = ce(n), s = _e(n), c = be(n) === "y", d = ["left", "top"].includes(i) ? -1 : 1, r = l && c ? -1 : 1, u = de(t, e);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: v
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return s && typeof v == "number" && (m = s === "end" ? v * -1 : v), c ? {
    x: m * r,
    y: f * d
  } : {
    x: f * d,
    y: m * r
  };
}
const vo = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: a,
        y: l,
        placement: i,
        middlewareData: s
      } = t, c = await mo(t, e);
      return i === ((n = s.offset) == null ? void 0 : n.placement) && (o = s.arrow) != null && o.alignmentOffset ? {} : {
        x: a + c.x,
        y: l + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, go = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: a
      } = t, {
        mainAxis: l = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (h) => {
            let {
              x: b,
              y: A
            } = h;
            return {
              x: b,
              y: A
            };
          }
        },
        ...c
      } = de(e, t), d = {
        x: n,
        y: o
      }, r = await Fe(t, c), u = be(ce(a)), f = wt(u);
      let m = d[f], v = d[u];
      if (l) {
        const h = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", A = m + r[h], g = m - r[b];
        m = pt(A, m, g);
      }
      if (i) {
        const h = u === "y" ? "top" : "left", b = u === "y" ? "bottom" : "right", A = v + r[h], g = v - r[b];
        v = pt(A, v, g);
      }
      const y = s.fn({
        ...t,
        [f]: m,
        [u]: v
      });
      return {
        ...y,
        data: {
          x: y.x - n,
          y: y.y - o,
          enabled: {
            [f]: l,
            [u]: i
          }
        }
      };
    }
  };
}, ho = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: o,
        placement: a,
        rects: l,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: d = !0
      } = de(e, t), r = {
        x: n,
        y: o
      }, u = be(a), f = wt(u);
      let m = r[f], v = r[u];
      const y = de(s, t), h = typeof y == "number" ? {
        mainAxis: y,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...y
      };
      if (c) {
        const g = f === "y" ? "height" : "width", x = l.reference[f] - l.floating[g] + h.mainAxis, C = l.reference[f] + l.reference[g] - h.mainAxis;
        m < x ? m = x : m > C && (m = C);
      }
      if (d) {
        var b, A;
        const g = f === "y" ? "width" : "height", x = ["top", "left"].includes(ce(a)), C = l.reference[u] - l.floating[g] + (x && ((b = i.offset) == null ? void 0 : b[u]) || 0) + (x ? 0 : h.crossAxis), D = l.reference[u] + l.reference[g] + (x ? 0 : ((A = i.offset) == null ? void 0 : A[u]) || 0) - (x ? h.crossAxis : 0);
        v < C ? v = C : v > D && (v = D);
      }
      return {
        [f]: m,
        [u]: v
      };
    }
  };
}, yo = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: a,
        rects: l,
        platform: i,
        elements: s
      } = t, {
        apply: c = () => {
        },
        ...d
      } = de(e, t), r = await Fe(t, d), u = ce(a), f = _e(a), m = be(a) === "y", {
        width: v,
        height: y
      } = l.floating;
      let h, b;
      u === "top" || u === "bottom" ? (h = u, b = f === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (b = u, h = f === "end" ? "top" : "bottom");
      const A = y - r.top - r.bottom, g = v - r.left - r.right, x = ye(y - r[h], A), C = ye(v - r[b], g), D = !t.middlewareData.shift;
      let $ = x, N = C;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (N = g), (o = t.middlewareData.shift) != null && o.enabled.y && ($ = A), D && !f) {
        const T = X(r.left, 0), Z = X(r.right, 0), H = X(r.top, 0), Y = X(r.bottom, 0);
        m ? N = v - 2 * (T !== 0 || Z !== 0 ? T + Z : X(r.left, r.right)) : $ = y - 2 * (H !== 0 || Y !== 0 ? H + Y : X(r.top, r.bottom));
      }
      await c({
        ...t,
        availableWidth: N,
        availableHeight: $
      });
      const W = await i.getDimensions(s.floating);
      return v !== W.width || y !== W.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function et() {
  return typeof window < "u";
}
function Oe(e) {
  return At(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function G(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function re(e) {
  var t;
  return (t = (At(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function At(e) {
  return et() ? e instanceof Node || e instanceof G(e).Node : !1;
}
function te(e) {
  return et() ? e instanceof Element || e instanceof G(e).Element : !1;
}
function ie(e) {
  return et() ? e instanceof HTMLElement || e instanceof G(e).HTMLElement : !1;
}
function Wt(e) {
  return !et() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof G(e).ShadowRoot;
}
function ze(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: a
  } = ne(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(a);
}
function bo(e) {
  return ["table", "td", "th"].includes(Oe(e));
}
function tt(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Et(e) {
  const t = Pt(), n = te(e) ? ne(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function wo(e) {
  let t = we(e);
  for (; ie(t) && !Re(t); ) {
    if (Et(t))
      return t;
    if (tt(t))
      return null;
    t = we(t);
  }
  return null;
}
function Pt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Re(e) {
  return ["html", "body", "#document"].includes(Oe(e));
}
function ne(e) {
  return G(e).getComputedStyle(e);
}
function nt(e) {
  return te(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function we(e) {
  if (Oe(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Wt(e) && e.host || // Fallback.
    re(e)
  );
  return Wt(t) ? t.host : t;
}
function rn(e) {
  const t = we(e);
  return Re(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ie(t) && ze(t) ? t : rn(t);
}
function Le(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const a = rn(e), l = a === ((o = e.ownerDocument) == null ? void 0 : o.body), i = G(a);
  if (l) {
    const s = vt(i);
    return t.concat(i, i.visualViewport || [], ze(a) ? a : [], s && n ? Le(s) : []);
  }
  return t.concat(a, Le(a, [], n));
}
function vt(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function sn(e) {
  const t = ne(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const a = ie(e), l = a ? e.offsetWidth : n, i = a ? e.offsetHeight : o, s = Xe(n) !== l || Xe(o) !== i;
  return s && (n = l, o = i), {
    width: n,
    height: o,
    $: s
  };
}
function Ot(e) {
  return te(e) ? e : e.contextElement;
}
function De(e) {
  const t = Ot(e);
  if (!ie(t))
    return le(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: a,
    $: l
  } = sn(t);
  let i = (l ? Xe(n.width) : n.width) / o, s = (l ? Xe(n.height) : n.height) / a;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const xo = /* @__PURE__ */ le(0);
function un(e) {
  const t = G(e);
  return !Pt() || !t.visualViewport ? xo : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Co(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== G(e) ? !1 : t;
}
function Ae(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), l = Ot(e);
  let i = le(1);
  t && (o ? te(o) && (i = De(o)) : i = De(e));
  const s = Co(l, n, o) ? un(l) : le(0);
  let c = (a.left + s.x) / i.x, d = (a.top + s.y) / i.y, r = a.width / i.x, u = a.height / i.y;
  if (l) {
    const f = G(l), m = o && te(o) ? G(o) : o;
    let v = f, y = vt(v);
    for (; y && o && m !== v; ) {
      const h = De(y), b = y.getBoundingClientRect(), A = ne(y), g = b.left + (y.clientLeft + parseFloat(A.paddingLeft)) * h.x, x = b.top + (y.clientTop + parseFloat(A.paddingTop)) * h.y;
      c *= h.x, d *= h.y, r *= h.x, u *= h.y, c += g, d += x, v = G(y), y = vt(v);
    }
  }
  return Ge({
    width: r,
    height: u,
    x: c,
    y: d
  });
}
function $t(e, t) {
  const n = nt(e).scrollLeft;
  return t ? t.left + n : Ae(re(e)).left + n;
}
function dn(e, t, n) {
  n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = o.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    $t(e, o)
  )), l = o.top + t.scrollTop;
  return {
    x: a,
    y: l
  };
}
function Ao(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: a
  } = e;
  const l = a === "fixed", i = re(o), s = t ? tt(t.floating) : !1;
  if (o === i || s && l)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = le(1);
  const r = le(0), u = ie(o);
  if ((u || !u && !l) && ((Oe(o) !== "body" || ze(i)) && (c = nt(o)), ie(o))) {
    const m = Ae(o);
    d = De(o), r.x = m.x + o.clientLeft, r.y = m.y + o.clientTop;
  }
  const f = i && !u && !l ? dn(i, c, !0) : le(0);
  return {
    width: n.width * d.x,
    height: n.height * d.y,
    x: n.x * d.x - c.scrollLeft * d.x + r.x + f.x,
    y: n.y * d.y - c.scrollTop * d.y + r.y + f.y
  };
}
function Eo(e) {
  return Array.from(e.getClientRects());
}
function Po(e) {
  const t = re(e), n = nt(e), o = e.ownerDocument.body, a = X(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), l = X(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -n.scrollLeft + $t(e);
  const s = -n.scrollTop;
  return ne(o).direction === "rtl" && (i += X(t.clientWidth, o.clientWidth) - a), {
    width: a,
    height: l,
    x: i,
    y: s
  };
}
function Oo(e, t) {
  const n = G(e), o = re(e), a = n.visualViewport;
  let l = o.clientWidth, i = o.clientHeight, s = 0, c = 0;
  if (a) {
    l = a.width, i = a.height;
    const d = Pt();
    (!d || d && t === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: l,
    height: i,
    x: s,
    y: c
  };
}
function $o(e, t) {
  const n = Ae(e, !0, t === "fixed"), o = n.top + e.clientTop, a = n.left + e.clientLeft, l = ie(e) ? De(e) : le(1), i = e.clientWidth * l.x, s = e.clientHeight * l.y, c = a * l.x, d = o * l.y;
  return {
    width: i,
    height: s,
    x: c,
    y: d
  };
}
function Ht(e, t, n) {
  let o;
  if (t === "viewport")
    o = Oo(e, n);
  else if (t === "document")
    o = Po(re(e));
  else if (te(t))
    o = $o(t, n);
  else {
    const a = un(e);
    o = {
      x: t.x - a.x,
      y: t.y - a.y,
      width: t.width,
      height: t.height
    };
  }
  return Ge(o);
}
function cn(e, t) {
  const n = we(e);
  return n === t || !te(n) || Re(n) ? !1 : ne(n).position === "fixed" || cn(n, t);
}
function ko(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = Le(e, [], !1).filter((s) => te(s) && Oe(s) !== "body"), a = null;
  const l = ne(e).position === "fixed";
  let i = l ? we(e) : e;
  for (; te(i) && !Re(i); ) {
    const s = ne(i), c = Et(i);
    !c && s.position === "fixed" && (a = null), (l ? !c && !a : !c && s.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || ze(i) && !c && cn(e, i)) ? o = o.filter((r) => r !== i) : a = s, i = we(i);
  }
  return t.set(e, o), o;
}
function Bo(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: a
  } = e;
  const i = [...n === "clippingAncestors" ? tt(t) ? [] : ko(t, this._c) : [].concat(n), o], s = i[0], c = i.reduce((d, r) => {
    const u = Ht(t, r, a);
    return d.top = X(u.top, d.top), d.right = ye(u.right, d.right), d.bottom = ye(u.bottom, d.bottom), d.left = X(u.left, d.left), d;
  }, Ht(t, s, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function So(e) {
  const {
    width: t,
    height: n
  } = sn(e);
  return {
    width: t,
    height: n
  };
}
function Do(e, t, n) {
  const o = ie(t), a = re(t), l = n === "fixed", i = Ae(e, !0, l, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = le(0);
  if (o || !o && !l)
    if ((Oe(t) !== "body" || ze(a)) && (s = nt(t)), o) {
      const f = Ae(t, !0, l, t);
      c.x = f.x + t.clientLeft, c.y = f.y + t.clientTop;
    } else a && (c.x = $t(a));
  const d = a && !o && !l ? dn(a, s) : le(0), r = i.left + s.scrollLeft - c.x - d.x, u = i.top + s.scrollTop - c.y - d.y;
  return {
    x: r,
    y: u,
    width: i.width,
    height: i.height
  };
}
function lt(e) {
  return ne(e).position === "static";
}
function jt(e, t) {
  if (!ie(e) || ne(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return re(e) === n && (n = n.ownerDocument.body), n;
}
function fn(e, t) {
  const n = G(e);
  if (tt(e))
    return n;
  if (!ie(e)) {
    let a = we(e);
    for (; a && !Re(a); ) {
      if (te(a) && !lt(a))
        return a;
      a = we(a);
    }
    return n;
  }
  let o = jt(e, t);
  for (; o && bo(o) && lt(o); )
    o = jt(o, t);
  return o && Re(o) && lt(o) && !Et(o) ? n : o || wo(e) || n;
}
const To = async function(e) {
  const t = this.getOffsetParent || fn, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: Do(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Ro(e) {
  return ne(e).direction === "rtl";
}
const Mo = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ao,
  getDocumentElement: re,
  getClippingRect: Bo,
  getOffsetParent: fn,
  getElementRects: To,
  getClientRects: Eo,
  getDimensions: So,
  getScale: De,
  isElement: te,
  isRTL: Ro
};
function pn(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function _o(e, t) {
  let n = null, o;
  const a = re(e);
  function l() {
    var s;
    clearTimeout(o), (s = n) == null || s.disconnect(), n = null;
  }
  function i(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), l();
    const d = e.getBoundingClientRect(), {
      left: r,
      top: u,
      width: f,
      height: m
    } = d;
    if (s || t(), !f || !m)
      return;
    const v = He(u), y = He(a.clientWidth - (r + f)), h = He(a.clientHeight - (u + m)), b = He(r), g = {
      rootMargin: -v + "px " + -y + "px " + -h + "px " + -b + "px",
      threshold: X(0, ye(1, c)) || 1
    };
    let x = !0;
    function C(D) {
      const $ = D[0].intersectionRatio;
      if ($ !== c) {
        if (!x)
          return i();
        $ ? i(!1, $) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      $ === 1 && !pn(d, e.getBoundingClientRect()) && i(), x = !1;
    }
    try {
      n = new IntersectionObserver(C, {
        ...g,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(C, g);
    }
    n.observe(e);
  }
  return i(!0), l;
}
function Io(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: l = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = o, d = Ot(e), r = a || l ? [...d ? Le(d) : [], ...Le(t)] : [];
  r.forEach((b) => {
    a && b.addEventListener("scroll", n, {
      passive: !0
    }), l && b.addEventListener("resize", n);
  });
  const u = d && s ? _o(d, n) : null;
  let f = -1, m = null;
  i && (m = new ResizeObserver((b) => {
    let [A] = b;
    A && A.target === d && m && (m.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var g;
      (g = m) == null || g.observe(t);
    })), n();
  }), d && !c && m.observe(d), m.observe(t));
  let v, y = c ? Ae(e) : null;
  c && h();
  function h() {
    const b = Ae(e);
    y && !pn(y, b) && n(), y = b, v = requestAnimationFrame(h);
  }
  return n(), () => {
    var b;
    r.forEach((A) => {
      a && A.removeEventListener("scroll", n), l && A.removeEventListener("resize", n);
    }), u == null || u(), (b = m) == null || b.disconnect(), m = null, c && cancelAnimationFrame(v);
  };
}
const No = vo, Fo = go, Ut = fo, Lo = yo, Vo = po, zo = co, Wo = ho, Ho = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), a = {
    platform: Mo,
    ...n
  }, l = {
    ...a.platform,
    _c: o
  };
  return uo(e, t, {
    ...a,
    platform: l
  });
};
function jo(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function gt(e) {
  if (jo(e)) {
    const t = e.$el;
    return At(t) && Oe(t) === "#comment" ? null : t;
  }
  return e;
}
function Be(e) {
  return typeof e == "function" ? e() : p(e);
}
function Uo(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const n = gt(Be(e.element));
      return n == null ? {} : zo({
        element: n,
        padding: e.padding
      }).fn(t);
    }
  };
}
function mn(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Kt(e, t) {
  const n = mn(e);
  return Math.round(t * n) / n;
}
function Ko(e, t, n) {
  n === void 0 && (n = {});
  const o = n.whileElementsMounted, a = P(() => {
    var $;
    return ($ = Be(n.open)) != null ? $ : !0;
  }), l = P(() => Be(n.middleware)), i = P(() => {
    var $;
    return ($ = Be(n.placement)) != null ? $ : "bottom";
  }), s = P(() => {
    var $;
    return ($ = Be(n.strategy)) != null ? $ : "absolute";
  }), c = P(() => {
    var $;
    return ($ = Be(n.transform)) != null ? $ : !0;
  }), d = P(() => gt(e.value)), r = P(() => gt(t.value)), u = O(0), f = O(0), m = O(s.value), v = O(i.value), y = Qt({}), h = O(!1), b = P(() => {
    const $ = {
      position: m.value,
      left: "0",
      top: "0"
    };
    if (!r.value)
      return $;
    const N = Kt(r.value, u.value), W = Kt(r.value, f.value);
    return c.value ? {
      ...$,
      transform: "translate(" + N + "px, " + W + "px)",
      ...mn(r.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: m.value,
      left: N + "px",
      top: W + "px"
    };
  });
  let A;
  function g() {
    if (d.value == null || r.value == null)
      return;
    const $ = a.value;
    Ho(d.value, r.value, {
      middleware: l.value,
      placement: i.value,
      strategy: s.value
    }).then((N) => {
      u.value = N.x, f.value = N.y, m.value = N.strategy, v.value = N.placement, y.value = N.middlewareData, h.value = $ !== !1;
    });
  }
  function x() {
    typeof A == "function" && (A(), A = void 0);
  }
  function C() {
    if (x(), o === void 0) {
      g();
      return;
    }
    if (d.value != null && r.value != null) {
      A = o(d.value, r.value, g);
      return;
    }
  }
  function D() {
    a.value || (h.value = !1);
  }
  return U([l, i, s, a], g, {
    flush: "sync"
  }), U([d, r], C, {
    flush: "sync"
  }), U(a, D, {
    flush: "sync"
  }), Zt() && en(x), {
    x: $e(u),
    y: $e(f),
    strategy: $e(m),
    placement: $e(v),
    middlewareData: $e(y),
    isPositioned: $e(h),
    floatingStyles: b,
    update: g
  };
}
function fe(e, t) {
  const n = typeof e == "string" && !t ? `${e}Context` : t, o = Symbol(n);
  return [(a) => {
    const l = Hn(o, a);
    if (l || l === null)
      return l;
    throw new Error(
      `Injection \`${o.toString()}\` not found. Component must be used within ${Array.isArray(e) ? `one of the following components: ${e.join(
        ", "
      )}` : `\`${e}\``}`
    );
  }, (a) => (jn(o, a), a)];
}
function vn(e, t, n) {
  const o = n.originalEvent.target, a = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, { once: !0 }), o.dispatchEvent(a);
}
function it(e) {
  return e == null;
}
function qo(e, t) {
  var n;
  const o = Qt();
  return ee(() => {
    o.value = e();
  }, {
    ...t,
    flush: (n = void 0) != null ? n : "sync"
  }), Jn(o);
}
function gn(e) {
  return Zt() ? (en(e), !0) : !1;
}
function Yo(e) {
  let t = !1, n;
  const o = on(!0);
  return (...a) => (t || (n = o.run(() => e(...a)), t = !0), n);
}
function Xo(e) {
  let t = 0, n, o;
  const a = () => {
    t -= 1, o && t <= 0 && (o.stop(), n = void 0, o = void 0);
  };
  return (...l) => (t += 1, n || (o = on(!0), n = o.run(() => e(...l))), gn(a), n);
}
function kt(e) {
  return typeof e == "function" ? e() : p(e);
}
const xe = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Jo = (e) => typeof e < "u", Go = Object.prototype.toString, Qo = (e) => Go.call(e) === "[object Object]", Zo = () => {
}, qt = /* @__PURE__ */ ea();
function ea() {
  var e, t;
  return xe && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function ta(e) {
  return Ee();
}
function na(e, t) {
  ta() && qn(e, t);
}
function Ie(e) {
  var t;
  const n = kt(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const Bt = xe ? window : void 0;
function hn(...e) {
  let t, n, o, a;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, o, a] = e, t = Bt) : [t, n, o, a] = e, !t)
    return Zo;
  Array.isArray(n) || (n = [n]), Array.isArray(o) || (o = [o]);
  const l = [], i = () => {
    l.forEach((r) => r()), l.length = 0;
  }, s = (r, u, f, m) => (r.addEventListener(u, f, m), () => r.removeEventListener(u, f, m)), c = U(
    () => [Ie(t), kt(a)],
    ([r, u]) => {
      if (i(), !r)
        return;
      const f = Qo(u) ? { ...u } : u;
      l.push(
        ...n.flatMap((m) => o.map((v) => s(r, m, v, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    c(), i();
  };
  return gn(d), d;
}
function oa(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function aa(...e) {
  let t, n, o = {};
  e.length === 3 ? (t = e[0], n = e[1], o = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, n = e[0], o = e[1]) : (t = e[0], n = e[1]) : (t = !0, n = e[0]);
  const {
    target: a = Bt,
    eventName: l = "keydown",
    passive: i = !1,
    dedupe: s = !1
  } = o, c = oa(t);
  return hn(a, l, (d) => {
    d.repeat && kt(s) || c(d) && n(d);
  }, i);
}
function la() {
  const e = O(!1), t = Ee();
  return t && Me(() => {
    e.value = !0;
  }, t), e;
}
function ia(e) {
  return JSON.parse(JSON.stringify(e));
}
function Ve(e, t, n, o = {}) {
  var a, l, i;
  const {
    clone: s = !1,
    passive: c = !1,
    eventName: d,
    deep: r = !1,
    defaultValue: u,
    shouldEmit: f
  } = o, m = Ee(), v = n || (m == null ? void 0 : m.emit) || ((a = m == null ? void 0 : m.$emit) == null ? void 0 : a.bind(m)) || ((i = (l = m == null ? void 0 : m.proxy) == null ? void 0 : l.$emit) == null ? void 0 : i.bind(m == null ? void 0 : m.proxy));
  let y = d;
  t || (t = "modelValue"), y = y || `update:${t.toString()}`;
  const h = (g) => s ? typeof s == "function" ? s(g) : ia(g) : g, b = () => Jo(e[t]) ? h(e[t]) : u, A = (g) => {
    f ? f(g) && v(y, g) : v(y, g);
  };
  if (c) {
    const g = b(), x = O(g);
    let C = !1;
    return U(
      () => e[t],
      (D) => {
        C || (C = !0, x.value = h(D), Pe(() => C = !1));
      }
    ), U(
      x,
      (D) => {
        !C && (D !== e[t] || r) && A(D);
      },
      { deep: r }
    ), x;
  } else
    return P({
      get() {
        return b();
      },
      set(g) {
        A(g);
      }
    });
}
function St(e) {
  return e ? e.flatMap((t) => t.type === ue ? St(t.children) : [t]) : [];
}
function Te() {
  let e = document.activeElement;
  if (e == null)
    return null;
  for (; e != null && e.shadowRoot != null && e.shadowRoot.activeElement != null; )
    e = e.shadowRoot.activeElement;
  return e;
}
const ra = ["INPUT", "TEXTAREA"];
function sa(e, t, n, o = {}) {
  if (!t || o.enableIgnoredElement && ra.includes(t.nodeName))
    return null;
  const {
    arrowKeyOptions: a = "both",
    attributeName: l = "[data-radix-vue-collection-item]",
    itemsArray: i = [],
    loop: s = !0,
    dir: c = "ltr",
    preventScroll: d = !0,
    focus: r = !1
  } = o, [u, f, m, v, y, h] = [
    e.key === "ArrowRight",
    e.key === "ArrowLeft",
    e.key === "ArrowUp",
    e.key === "ArrowDown",
    e.key === "Home",
    e.key === "End"
  ], b = m || v, A = u || f;
  if (!y && !h && (!b && !A || a === "vertical" && A || a === "horizontal" && b))
    return null;
  const g = n ? Array.from(n.querySelectorAll(l)) : i;
  if (!g.length)
    return null;
  d && e.preventDefault();
  let x = null;
  return A || b ? x = yn(g, t, {
    goForward: b ? v : c === "ltr" ? u : f,
    loop: s
  }) : y ? x = g.at(0) || null : h && (x = g.at(-1) || null), r && (x == null || x.focus()), x;
}
function yn(e, t, n, o = e.length) {
  if (--o === 0)
    return null;
  const a = e.indexOf(t), l = n.goForward ? a + 1 : a - 1;
  if (!n.loop && (l < 0 || l >= e.length))
    return null;
  const i = (l + e.length) % e.length, s = e[i];
  return s ? s.hasAttribute("disabled") && s.getAttribute("disabled") !== "false" ? yn(
    e,
    s,
    n,
    o
  ) : s : null;
}
function rt(e) {
  if (e === null || typeof e != "object")
    return !1;
  const t = Object.getPrototypeOf(e);
  return t !== null && t !== Object.prototype && Object.getPrototypeOf(t) !== null || Symbol.iterator in e ? !1 : Symbol.toStringTag in e ? Object.prototype.toString.call(e) === "[object Module]" : !0;
}
function ht(e, t, n = ".", o) {
  if (!rt(t))
    return ht(e, {}, n);
  const a = Object.assign({}, t);
  for (const l in e) {
    if (l === "__proto__" || l === "constructor")
      continue;
    const i = e[l];
    i != null && (Array.isArray(i) && Array.isArray(a[l]) ? a[l] = [...i, ...a[l]] : rt(i) && rt(a[l]) ? a[l] = ht(
      i,
      a[l],
      (n ? `${n}.` : "") + l.toString()
    ) : a[l] = i);
  }
  return a;
}
function ua(e) {
  return (...t) => (
    // eslint-disable-next-line unicorn/no-array-reduce
    t.reduce((n, o) => ht(n, o, ""), {})
  );
}
const da = ua(), [Dt, Ul] = fe("ConfigProvider");
let ca = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", fa = (e = 21) => {
  let t = "", n = e;
  for (; n--; )
    t += ca[Math.random() * 64 | 0];
  return t;
};
const pa = Xo(() => {
  const e = O(/* @__PURE__ */ new Map()), t = O(), n = P(() => {
    for (const i of e.value.values())
      if (i)
        return !0;
    return !1;
  }), o = Dt({
    scrollBody: O(!0)
  });
  let a = null;
  const l = () => {
    document.body.style.paddingRight = "", document.body.style.marginRight = "", document.body.style.pointerEvents = "", document.body.style.removeProperty("--scrollbar-width"), document.body.style.overflow = t.value ?? "", qt && (a == null || a()), t.value = void 0;
  };
  return U(n, (i, s) => {
    var c;
    if (!xe)
      return;
    if (!i) {
      s && l();
      return;
    }
    t.value === void 0 && (t.value = document.body.style.overflow);
    const d = window.innerWidth - document.documentElement.clientWidth, r = { padding: d, margin: 0 }, u = (c = o.scrollBody) != null && c.value ? typeof o.scrollBody.value == "object" ? da({
      padding: o.scrollBody.value.padding === !0 ? d : o.scrollBody.value.padding,
      margin: o.scrollBody.value.margin === !0 ? d : o.scrollBody.value.margin
    }, r) : r : { padding: 0, margin: 0 };
    d > 0 && (document.body.style.paddingRight = typeof u.padding == "number" ? `${u.padding}px` : String(u.padding), document.body.style.marginRight = typeof u.margin == "number" ? `${u.margin}px` : String(u.margin), document.body.style.setProperty("--scrollbar-width", `${d}px`), document.body.style.overflow = "hidden"), qt && (a = hn(
      document,
      "touchmove",
      (f) => va(f),
      { passive: !1 }
    )), Pe(() => {
      document.body.style.pointerEvents = "none", document.body.style.overflow = "hidden";
    });
  }, { immediate: !0, flush: "sync" }), e;
});
function ma(e) {
  const t = fa(6), n = pa();
  n.value.set(t, e);
  const o = P({
    get: () => n.value.get(t) ?? !1,
    set: (a) => n.value.set(t, a)
  });
  return na(() => {
    n.value.delete(t);
  }), o;
}
function bn(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const n = e.parentNode;
    return !n || n.tagName === "BODY" ? !1 : bn(n);
  }
}
function va(e) {
  const t = e || window.event, n = t.target;
  return n instanceof Element && bn(n) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.cancelable && t.preventDefault(), !1);
}
function ga(e) {
  const t = Dt({
    dir: O("ltr")
  });
  return P(() => {
    var n;
    return (e == null ? void 0 : e.value) || ((n = t.dir) == null ? void 0 : n.value) || "ltr";
  });
}
function ha(e) {
  const t = Ee(), n = t == null ? void 0 : t.type.emits, o = {};
  return n != null && n.length || console.warn(
    `No emitted event found. Please check component: ${t == null ? void 0 : t.type.__name}`
  ), n == null || n.forEach((a) => {
    o[Un(an(a))] = (...l) => e(a, ...l);
  }), o;
}
let st = 0;
function ya() {
  ee((e) => {
    if (!xe)
      return;
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement(
      "afterbegin",
      t[0] ?? Yt()
    ), document.body.insertAdjacentElement(
      "beforeend",
      t[1] ?? Yt()
    ), st++, e(() => {
      st === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((n) => n.remove()), st--;
    });
  });
}
function Yt() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
function wn(e) {
  const t = Ee(), n = Object.keys((t == null ? void 0 : t.type.props) ?? {}).reduce((a, l) => {
    const i = (t == null ? void 0 : t.type.props[l]).default;
    return i !== void 0 && (a[l] = i), a;
  }, {}), o = Kn(e);
  return P(() => {
    const a = {}, l = (t == null ? void 0 : t.vnode.props) ?? {};
    return Object.keys(l).forEach((i) => {
      a[an(i)] = l[i];
    }), Object.keys({ ...n, ...a }).reduce((i, s) => (o.value[s] !== void 0 && (i[s] = o.value[s]), i), {});
  });
}
function Tt(e, t) {
  const n = wn(e), o = t ? ha(t) : {};
  return P(() => ({
    ...n.value,
    ...o
  }));
}
function I() {
  const e = Ee(), t = O(), n = P(() => {
    var i, s;
    return ["#text", "#comment"].includes((i = t.value) == null ? void 0 : i.$el.nodeName) ? (s = t.value) == null ? void 0 : s.$el.nextElementSibling : Ie(t);
  }), o = Object.assign({}, e.exposed), a = {};
  for (const i in e.props)
    Object.defineProperty(a, i, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[i]
    });
  if (Object.keys(o).length > 0)
    for (const i in o)
      Object.defineProperty(a, i, {
        enumerable: !0,
        configurable: !0,
        get: () => o[i]
      });
  Object.defineProperty(a, "$el", {
    enumerable: !0,
    configurable: !0,
    get: () => e.vnode.el
  }), e.exposed = a;
  function l(i) {
    t.value = i, !(i instanceof Element || !i) && (Object.defineProperty(a, "$el", {
      enumerable: !0,
      configurable: !0,
      get: () => i.$el
    }), e.exposed = a);
  }
  return { forwardRef: l, currentRef: t, currentElement: n };
}
var ba = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, ke = /* @__PURE__ */ new WeakMap(), je = /* @__PURE__ */ new WeakMap(), Ue = {}, ut = 0, xn = function(e) {
  return e && (e.host || xn(e.parentNode));
}, wa = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = xn(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, xa = function(e, t, n, o) {
  var a = wa(t, Array.isArray(e) ? e : [e]);
  Ue[n] || (Ue[n] = /* @__PURE__ */ new WeakMap());
  var l = Ue[n], i = [], s = /* @__PURE__ */ new Set(), c = new Set(a), d = function(u) {
    !u || s.has(u) || (s.add(u), d(u.parentNode));
  };
  a.forEach(d);
  var r = function(u) {
    !u || c.has(u) || Array.prototype.forEach.call(u.children, function(f) {
      if (s.has(f))
        r(f);
      else
        try {
          var m = f.getAttribute(o), v = m !== null && m !== "false", y = (ke.get(f) || 0) + 1, h = (l.get(f) || 0) + 1;
          ke.set(f, y), l.set(f, h), i.push(f), y === 1 && v && je.set(f, !0), h === 1 && f.setAttribute(n, "true"), v || f.setAttribute(o, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", f, b);
        }
    });
  };
  return r(t), s.clear(), ut++, function() {
    i.forEach(function(u) {
      var f = ke.get(u) - 1, m = l.get(u) - 1;
      ke.set(u, f), l.set(u, m), f || (je.has(u) || u.removeAttribute(o), je.delete(u)), m || u.removeAttribute(n);
    }), ut--, ut || (ke = /* @__PURE__ */ new WeakMap(), ke = /* @__PURE__ */ new WeakMap(), je = /* @__PURE__ */ new WeakMap(), Ue = {});
  };
}, Ca = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), a = ba(e);
  return a ? (o.push.apply(o, Array.from(a.querySelectorAll("[aria-live]"))), xa(o, a, n, "aria-hidden")) : function() {
    return null;
  };
};
function Aa(e) {
  let t;
  U(() => Ie(e), (n) => {
    n ? t = Ca(n) : t && t();
  }), bt(() => {
    t && t();
  });
}
let Ea = 0;
function Rt(e, t = "radix") {
  const n = Dt({ useId: void 0 });
  return It.useId ? `${t}-${It.useId()}` : n.useId ? `${t}-${n.useId()}` : `${t}-${++Ea}`;
}
function Pa(e) {
  const t = O(), n = P(() => {
    var a;
    return ((a = t.value) == null ? void 0 : a.width) ?? 0;
  }), o = P(() => {
    var a;
    return ((a = t.value) == null ? void 0 : a.height) ?? 0;
  });
  return Me(() => {
    const a = Ie(e);
    if (a) {
      t.value = { width: a.offsetWidth, height: a.offsetHeight };
      const l = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const s = i[0];
        let c, d;
        if ("borderBoxSize" in s) {
          const r = s.borderBoxSize, u = Array.isArray(r) ? r[0] : r;
          c = u.inlineSize, d = u.blockSize;
        } else
          c = a.offsetWidth, d = a.offsetHeight;
        t.value = { width: c, height: d };
      });
      return l.observe(a, { box: "border-box" }), () => l.unobserve(a);
    } else
      t.value = void 0;
  }), {
    width: n,
    height: o
  };
}
function Oa(e, t) {
  const n = O(e);
  function o(a) {
    return t[n.value][a] ?? n.value;
  }
  return {
    state: n,
    dispatch: (a) => {
      n.value = o(a);
    }
  };
}
const Mt = B({
  name: "PrimitiveSlot",
  inheritAttrs: !1,
  setup(e, { attrs: t, slots: n }) {
    return () => {
      var o, a;
      if (!n.default)
        return null;
      const l = St(n.default()), i = l.findIndex((r) => r.type !== Nn);
      if (i === -1)
        return l;
      const s = l[i];
      (o = s.props) == null || delete o.ref;
      const c = s.props ? z(t, s.props) : t;
      t.class && (a = s.props) != null && a.class && delete s.props.class;
      const d = Fn(s, c);
      for (const r in c)
        r.startsWith("on") && (d.props || (d.props = {}), d.props[r] = c[r]);
      return l.length === 1 ? d : (l[i] = d, l);
    };
  }
}), L = B({
  name: "Primitive",
  inheritAttrs: !1,
  props: {
    asChild: {
      type: Boolean,
      default: !1
    },
    as: {
      type: [String, Object],
      default: "div"
    }
  },
  setup(e, { attrs: t, slots: n }) {
    const o = e.asChild ? "template" : e.as;
    return typeof o == "string" && ["area", "img", "input"].includes(o) ? () => Se(o, t) : o !== "template" ? () => Se(e.as, t, { default: n.default }) : () => Se(Mt, t, { default: n.default });
  }
});
function Cn() {
  const e = O(), t = P(() => {
    var n, o;
    return ["#text", "#comment"].includes((n = e.value) == null ? void 0 : n.$el.nodeName) ? (o = e.value) == null ? void 0 : o.$el.nextElementSibling : Ie(e);
  });
  return {
    primitiveElement: e,
    currentElement: t
  };
}
const [An, $a] = fe("CollapsibleRoot"), ka = /* @__PURE__ */ B({
  __name: "CollapsibleRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:open"],
  setup(e, { expose: t, emit: n }) {
    const o = e, a = Ve(o, "open", n, {
      defaultValue: o.defaultOpen,
      passive: o.open === void 0
    }), l = Ve(o, "disabled");
    return $a({
      contentId: "",
      disabled: l,
      open: a,
      onOpenToggle: () => {
        a.value = !a.value;
      }
    }), t({ open: a }), I(), (i, s) => (w(), k(p(L), {
      as: i.as,
      "as-child": o.asChild,
      "data-state": p(a) ? "open" : "closed",
      "data-disabled": p(l) ? "" : void 0
    }, {
      default: E(() => [
        S(i.$slots, "default", { open: p(a) })
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-state", "data-disabled"]));
  }
}), Ba = /* @__PURE__ */ B({
  __name: "CollapsibleTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const t = e;
    I();
    const n = An();
    return (o, a) => {
      var l, i;
      return w(), k(p(L), {
        type: o.as === "button" ? "button" : void 0,
        as: o.as,
        "as-child": t.asChild,
        "aria-controls": p(n).contentId,
        "aria-expanded": p(n).open.value,
        "data-state": p(n).open.value ? "open" : "closed",
        "data-disabled": (l = p(n).disabled) != null && l.value ? "" : void 0,
        disabled: (i = p(n).disabled) == null ? void 0 : i.value,
        onClick: p(n).onOpenToggle
      }, {
        default: E(() => [
          S(o.$slots, "default")
        ]),
        _: 3
      }, 8, ["type", "as", "as-child", "aria-controls", "aria-expanded", "data-state", "data-disabled", "disabled", "onClick"]);
    };
  }
});
function Sa(e, t) {
  var n;
  const o = O({}), a = O("none"), l = O(e), i = e.value ? "mounted" : "unmounted";
  let s;
  const c = ((n = t.value) == null ? void 0 : n.ownerDocument.defaultView) ?? Bt, { state: d, dispatch: r } = Oa(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  }), u = (h) => {
    var b;
    if (xe) {
      const A = new CustomEvent(h, { bubbles: !1, cancelable: !1 });
      (b = t.value) == null || b.dispatchEvent(A);
    }
  };
  U(
    e,
    async (h, b) => {
      var A;
      const g = b !== h;
      if (await Pe(), g) {
        const x = a.value, C = Ke(t.value);
        h ? (r("MOUNT"), u("enter"), C === "none" && u("after-enter")) : C === "none" || ((A = o.value) == null ? void 0 : A.display) === "none" ? (r("UNMOUNT"), u("leave"), u("after-leave")) : b && x !== C ? (r("ANIMATION_OUT"), u("leave")) : (r("UNMOUNT"), u("after-leave"));
      }
    },
    { immediate: !0 }
  );
  const f = (h) => {
    const b = Ke(t.value), A = b.includes(
      h.animationName
    ), g = d.value === "mounted" ? "enter" : "leave";
    if (h.target === t.value && A && (u(`after-${g}`), r("ANIMATION_END"), !l.value)) {
      const x = t.value.style.animationFillMode;
      t.value.style.animationFillMode = "forwards", s = c == null ? void 0 : c.setTimeout(() => {
        var C;
        ((C = t.value) == null ? void 0 : C.style.animationFillMode) === "forwards" && (t.value.style.animationFillMode = x);
      });
    }
    h.target === t.value && b === "none" && r("ANIMATION_END");
  }, m = (h) => {
    h.target === t.value && (a.value = Ke(t.value));
  }, v = U(
    t,
    (h, b) => {
      h ? (o.value = getComputedStyle(h), h.addEventListener("animationstart", m), h.addEventListener("animationcancel", f), h.addEventListener("animationend", f)) : (r("ANIMATION_END"), c == null || c.clearTimeout(s), b == null || b.removeEventListener("animationstart", m), b == null || b.removeEventListener("animationcancel", f), b == null || b.removeEventListener("animationend", f));
    },
    { immediate: !0 }
  ), y = U(d, () => {
    const h = Ke(t.value);
    a.value = d.value === "mounted" ? h : "none";
  });
  return bt(() => {
    v(), y();
  }), {
    isPresent: P(
      () => ["mounted", "unmountSuspended"].includes(d.value)
    )
  };
}
function Ke(e) {
  return e && getComputedStyle(e).animationName || "none";
}
const En = B({
  name: "Presence",
  props: {
    present: {
      type: Boolean,
      required: !0
    },
    forceMount: {
      type: Boolean
    }
  },
  slots: {},
  setup(e, { slots: t, expose: n }) {
    var o;
    const { present: a, forceMount: l } = Qe(e), i = O(), { isPresent: s } = Sa(a, i);
    n({ present: s });
    let c = t.default({ present: s });
    c = St(c || []);
    const d = Ee();
    if (c && (c == null ? void 0 : c.length) > 1) {
      const r = (o = d == null ? void 0 : d.parent) != null && o.type.name ? `<${d.parent.type.name} />` : "component";
      throw new Error(
        [
          `Detected an invalid children for \`${r}\` for  \`Presence\` component.`,
          "",
          "Note: Presence works similarly to `v-if` directly, but it waits for animation/transition to finished before unmounting. So it expect only one direct child of valid VNode type.",
          "You can apply a few solutions:",
          [
            "Provide a single child element so that `presence` directive attach correctly.",
            "Ensure the first child is an actual element instead of a raw text node or comment node."
          ].map((u) => `  - ${u}`).join(`
`)
        ].join(`
`)
      );
    }
    return () => l.value || a.value || s.value ? Se(t.default({ present: s })[0], {
      ref: (r) => {
        const u = Ie(r);
        return typeof (u == null ? void 0 : u.hasAttribute) > "u" || (u != null && u.hasAttribute("data-radix-popper-content-wrapper") ? i.value = u.firstElementChild : i.value = u), u;
      }
    }) : null;
  }
}), Da = /* @__PURE__ */ B({
  inheritAttrs: !1,
  __name: "CollapsibleContent",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = e, n = An();
    n.contentId || (n.contentId = Rt(void 0, "radix-vue-collapsible-content"));
    const o = O(), { forwardRef: a, currentElement: l } = I(), i = O(0), s = O(0), c = P(() => n.open.value), d = O(c.value), r = O();
    return U(
      () => {
        var u;
        return [c.value, (u = o.value) == null ? void 0 : u.present];
      },
      async () => {
        await Pe();
        const u = l.value;
        if (!u)
          return;
        r.value = r.value || {
          transitionDuration: u.style.transitionDuration,
          animationName: u.style.animationName
        }, u.style.transitionDuration = "0s", u.style.animationName = "none";
        const f = u.getBoundingClientRect();
        s.value = f.height, i.value = f.width, d.value || (u.style.transitionDuration = r.value.transitionDuration, u.style.animationName = r.value.animationName);
      },
      {
        immediate: !0
      }
    ), Me(() => {
      requestAnimationFrame(() => {
        d.value = !1;
      });
    }), (u, f) => (w(), k(p(En), {
      ref_key: "presentRef",
      ref: o,
      present: u.forceMount || p(n).open.value,
      "force-mount": !0
    }, {
      default: E(() => {
        var m, v;
        return [
          R(p(L), z(u.$attrs, {
            id: p(n).contentId,
            ref: p(a),
            "as-child": t.asChild,
            as: u.as,
            "data-state": p(n).open.value ? "open" : "closed",
            "data-disabled": (m = p(n).disabled) != null && m.value ? "" : void 0,
            hidden: !((v = o.value) != null && v.present),
            style: {
              "--radix-collapsible-content-height": `${s.value}px`,
              "--radix-collapsible-content-width": `${i.value}px`
            }
          }), {
            default: E(() => {
              var y;
              return [
                (y = o.value) != null && y.present ? S(u.$slots, "default", { key: 0 }) : j("", !0)
              ];
            }),
            _: 3
          }, 16, ["id", "as-child", "as", "data-state", "data-disabled", "hidden", "style"])
        ];
      }),
      _: 3
    }, 8, ["present"]));
  }
});
function Pn({ type: e, defaultValue: t, modelValue: n }) {
  const o = n || t;
  if (it(e) && it(n) && it(t))
    throw new Error("Either the `type` or the `value` or `default-value` prop must be defined.");
  if (n !== void 0 && t !== void 0 && typeof n != typeof t)
    throw new Error(
      `Invalid prop \`value\` of value \`${n}\` supplied, should be the same type as the \`defaultValue\` prop, which is \`${t}\`. The \`value\` prop must be:
  ${e === "single" ? "- a string" : e === "multiple" ? "- an array of strings" : `- a string
- an array of strings`}
  - \`undefined\``
    );
  const a = n !== void 0 || t !== void 0;
  if (e && a) {
    const l = Array.isArray(n) || Array.isArray(t), i = n !== void 0 ? "modelValue" : "defaultValue", s = i === "modelValue" ? typeof n : typeof t;
    if (e === "single" && l)
      return console.error(`Invalid prop \`${i}\` of type ${s} supplied with type \`single\`. The \`modelValue\` prop must be a string or \`undefined\`.
    You can remove the \`type\` prop to let the component infer the type from the ${i} prop.`), "multiple";
    if (e === "multiple" && !l)
      return console.error(`Invalid prop \`${i}\` of type ${s} supplied with type \`multiple\`. The \`modelValue\` prop must be an array of strings or \`undefined\`.
    You can remove the \`type\` prop to let the component infer the type from the ${i} prop.`), "single";
  }
  return a ? Array.isArray(o) ? "multiple" : "single" : e;
}
function Ta({ type: e, defaultValue: t, modelValue: n }) {
  return e || Pn({ type: e, defaultValue: t, modelValue: n });
}
function Ra({ type: e, defaultValue: t }) {
  return t !== void 0 ? t : e === "single" ? void 0 : [];
}
function Ma(e, t) {
  const n = O(Ta(e)), o = Ve(e, "modelValue", t, {
    defaultValue: Ra(e),
    passive: e.modelValue === void 0,
    deep: !0
  });
  U(
    () => [e.type, e.modelValue, e.defaultValue],
    () => {
      const i = Pn(e);
      n.value !== i && (n.value = i);
    },
    { immediate: !0 }
  );
  function a(i) {
    if (n.value === "single")
      o.value = i === o.value ? void 0 : i;
    else {
      const s = [...o.value || []];
      if (s.includes(i)) {
        const c = s.findIndex((d) => d === i);
        s.splice(c, 1);
      } else
        s.push(i);
      o.value = s;
    }
  }
  const l = P(() => n.value === "single");
  return {
    modelValue: o,
    type: n,
    changeModelValue: a,
    isSingle: l
  };
}
const [ot, _a] = fe("AccordionRoot"), On = /* @__PURE__ */ B({
  __name: "AccordionRoot",
  props: {
    collapsible: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    dir: {},
    orientation: { default: "vertical" },
    asChild: { type: Boolean },
    as: {},
    type: {},
    modelValue: {},
    defaultValue: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, o = t, { dir: a, disabled: l } = Qe(n), i = ga(a), { modelValue: s, changeModelValue: c, isSingle: d } = Ma(n, o), { forwardRef: r, currentElement: u } = I();
    return _a({
      disabled: l,
      direction: i,
      orientation: n.orientation,
      parentElement: u,
      isSingle: d,
      collapsible: n.collapsible,
      modelValue: s,
      changeModelValue: c
    }), (f, m) => (w(), k(p(L), {
      ref: p(r),
      "as-child": f.asChild,
      as: f.as
    }, {
      default: E(() => [
        S(f.$slots, "default", { modelValue: p(s) })
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
}), [_t, Ia] = fe("AccordionItem"), $n = /* @__PURE__ */ B({
  __name: "AccordionItem",
  props: {
    disabled: { type: Boolean },
    value: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(e, { expose: t }) {
    const n = e, o = ot(), a = P(
      () => o.isSingle.value ? n.value === o.modelValue.value : Array.isArray(o.modelValue.value) && o.modelValue.value.includes(n.value)
    ), l = P(() => o.disabled.value || n.disabled), i = P(() => l.value ? "" : void 0), s = P(
      () => a.value ? "open" : "closed"
      /* Closed */
    );
    t({ open: a, dataDisabled: i });
    const { currentRef: c, currentElement: d } = I();
    Ia({
      open: a,
      dataState: s,
      disabled: l,
      dataDisabled: i,
      triggerId: "",
      currentRef: c,
      currentElement: d,
      value: P(() => n.value)
    });
    function r(u) {
      var f;
      const m = u.target;
      if (Array.from(((f = o.parentElement.value) == null ? void 0 : f.querySelectorAll("[data-radix-vue-collection-item]")) ?? []).findIndex((v) => v === m) === -1)
        return null;
      sa(
        u,
        d.value,
        o.parentElement.value,
        {
          arrowKeyOptions: o.orientation,
          dir: o.direction.value,
          focus: !0
        }
      );
    }
    return (u, f) => (w(), k(p(ka), {
      "data-orientation": p(o).orientation,
      "data-disabled": i.value,
      "data-state": s.value,
      disabled: l.value,
      open: a.value,
      as: n.as,
      "as-child": n.asChild,
      onKeydown: Ln(r, ["up", "down", "left", "right", "home", "end"])
    }, {
      default: E(() => [
        S(u.$slots, "default", { open: a.value })
      ]),
      _: 3
    }, 8, ["data-orientation", "data-disabled", "data-state", "disabled", "open", "as", "as-child"]));
  }
}), kn = /* @__PURE__ */ B({
  __name: "AccordionContent",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = e, n = ot(), o = _t();
    return I(), (a, l) => (w(), k(p(Da), {
      role: "region",
      hidden: !p(o).open.value,
      "as-child": t.asChild,
      "force-mount": t.forceMount,
      "aria-labelledby": p(o).triggerId,
      "data-state": p(o).dataState.value,
      "data-disabled": p(o).dataDisabled.value,
      "data-orientation": p(n).orientation,
      style: { "--radix-accordion-content-width": "var(--radix-collapsible-content-width)", "--radix-accordion-content-height": "var(--radix-collapsible-content-height)" }
    }, {
      default: E(() => [
        S(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["hidden", "as-child", "force-mount", "aria-labelledby", "data-state", "data-disabled", "data-orientation"]));
  }
}), Bn = /* @__PURE__ */ B({
  __name: "AccordionHeader",
  props: {
    asChild: { type: Boolean },
    as: { default: "h3" }
  },
  setup(e) {
    const t = e, n = ot(), o = _t();
    return I(), (a, l) => (w(), k(p(L), {
      as: t.as,
      "as-child": t.asChild,
      "data-orientation": p(n).orientation,
      "data-state": p(o).dataState.value,
      "data-disabled": p(o).dataDisabled.value
    }, {
      default: E(() => [
        S(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-orientation", "data-state", "data-disabled"]));
  }
}), Sn = /* @__PURE__ */ B({
  __name: "AccordionTrigger",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = e, n = ot(), o = _t();
    o.triggerId || (o.triggerId = Rt(void 0, "radix-vue-accordion-trigger"));
    function a() {
      const l = n.isSingle.value && o.open.value && !n.collapsible;
      o.disabled.value || l || n.changeModelValue(o.value.value);
    }
    return (l, i) => (w(), k(p(Ba), {
      id: p(o).triggerId,
      ref: p(o).currentRef,
      "data-radix-vue-collection-item": "",
      as: t.as,
      "as-child": t.asChild,
      "aria-disabled": p(o).disabled.value || void 0,
      "aria-expanded": p(o).open.value || !1,
      "data-disabled": p(o).dataDisabled.value,
      "data-orientation": p(n).orientation,
      "data-state": p(o).dataState.value,
      disabled: p(o).disabled.value,
      onClick: a
    }, {
      default: E(() => [
        S(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "as", "as-child", "aria-disabled", "aria-expanded", "data-disabled", "data-orientation", "data-state", "disabled"]));
  }
}), Na = /* @__PURE__ */ B({
  __name: "Teleport",
  props: {
    to: { default: "body" },
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(e) {
    const t = la();
    return (n, o) => p(t) || n.forceMount ? (w(), k(Wn, {
      key: 0,
      to: n.to,
      disabled: n.disabled
    }, [
      S(n.$slots, "default")
    ], 8, ["to", "disabled"])) : j("", !0);
  }
}), Fa = "dismissableLayer.pointerDownOutside", La = "dismissableLayer.focusOutside";
function Dn(e, t) {
  const n = t.closest(
    "[data-dismissable-layer]"
  ), o = e.dataset.dismissableLayer === "" ? e : e.querySelector(
    "[data-dismissable-layer]"
  ), a = Array.from(
    e.ownerDocument.querySelectorAll("[data-dismissable-layer]")
  );
  return !!(n && o === n || a.indexOf(o) < a.indexOf(n));
}
function Va(e, t) {
  var n;
  const o = ((n = t == null ? void 0 : t.value) == null ? void 0 : n.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), a = O(!1), l = O(() => {
  });
  return ee((i) => {
    if (!xe)
      return;
    const s = async (d) => {
      const r = d.target;
      if (t != null && t.value) {
        if (Dn(t.value, r)) {
          a.value = !1;
          return;
        }
        if (d.target && !a.value) {
          let u = function() {
            vn(
              Fa,
              e,
              f
            );
          };
          const f = { originalEvent: d };
          d.pointerType === "touch" ? (o.removeEventListener("click", l.value), l.value = u, o.addEventListener("click", l.value, {
            once: !0
          })) : u();
        } else
          o.removeEventListener("click", l.value);
        a.value = !1;
      }
    }, c = window.setTimeout(() => {
      o.addEventListener("pointerdown", s);
    }, 0);
    i(() => {
      window.clearTimeout(c), o.removeEventListener("pointerdown", s), o.removeEventListener("click", l.value);
    });
  }), {
    onPointerDownCapture: () => a.value = !0
  };
}
function za(e, t) {
  var n;
  const o = ((n = t == null ? void 0 : t.value) == null ? void 0 : n.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), a = O(!1);
  return ee((l) => {
    if (!xe)
      return;
    const i = async (s) => {
      t != null && t.value && (await Pe(), !(!t.value || Dn(t.value, s.target)) && s.target && !a.value && vn(
        La,
        e,
        { originalEvent: s }
      ));
    };
    o.addEventListener("focusin", i), l(() => o.removeEventListener("focusin", i));
  }), {
    onFocusCapture: () => a.value = !0,
    onBlurCapture: () => a.value = !1
  };
}
const se = Ze({
  layersRoot: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Wa = /* @__PURE__ */ B({
  __name: "DismissableLayer",
  props: {
    disableOutsidePointerEvents: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss"],
  setup(e, { emit: t }) {
    const n = e, o = t, { forwardRef: a, currentElement: l } = I(), i = P(
      () => {
        var v;
        return ((v = l.value) == null ? void 0 : v.ownerDocument) ?? globalThis.document;
      }
    ), s = P(() => se.layersRoot), c = P(() => l.value ? Array.from(s.value).indexOf(l.value) : -1), d = P(() => se.layersWithOutsidePointerEventsDisabled.size > 0), r = P(() => {
      const v = Array.from(s.value), [y] = [...se.layersWithOutsidePointerEventsDisabled].slice(-1), h = v.indexOf(y);
      return c.value >= h;
    }), u = Va(async (v) => {
      const y = [...se.branches].some(
        (h) => h == null ? void 0 : h.contains(v.target)
      );
      !r.value || y || (o("pointerDownOutside", v), o("interactOutside", v), await Pe(), v.defaultPrevented || o("dismiss"));
    }, l), f = za((v) => {
      [...se.branches].some(
        (y) => y == null ? void 0 : y.contains(v.target)
      ) || (o("focusOutside", v), o("interactOutside", v), v.defaultPrevented || o("dismiss"));
    }, l);
    aa("Escape", (v) => {
      c.value === s.value.size - 1 && (o("escapeKeyDown", v), v.defaultPrevented || o("dismiss"));
    });
    let m;
    return ee((v) => {
      l.value && (n.disableOutsidePointerEvents && (se.layersWithOutsidePointerEventsDisabled.size === 0 && (m = i.value.body.style.pointerEvents, i.value.body.style.pointerEvents = "none"), se.layersWithOutsidePointerEventsDisabled.add(l.value)), s.value.add(l.value), v(() => {
        n.disableOutsidePointerEvents && se.layersWithOutsidePointerEventsDisabled.size === 1 && (i.value.body.style.pointerEvents = m);
      }));
    }), ee((v) => {
      v(() => {
        l.value && (s.value.delete(l.value), se.layersWithOutsidePointerEventsDisabled.delete(l.value));
      });
    }), (v, y) => (w(), k(p(L), {
      ref: p(a),
      "as-child": v.asChild,
      as: v.as,
      "data-dismissable-layer": "",
      style: ae({
        pointerEvents: d.value ? r.value ? "auto" : "none" : void 0
      }),
      onFocusCapture: p(f).onFocusCapture,
      onBlurCapture: p(f).onBlurCapture,
      onPointerdownCapture: p(u).onPointerDownCapture
    }, {
      default: E(() => [
        S(v.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "style", "onFocusCapture", "onBlurCapture", "onPointerdownCapture"]));
  }
}), dt = "focusScope.autoFocusOnMount", ct = "focusScope.autoFocusOnUnmount", Xt = { bubbles: !1, cancelable: !0 };
function Ha(e, { select: t = !1 } = {}) {
  const n = Te();
  for (const o of e)
    if (he(o, { select: t }), Te() !== n)
      return !0;
}
function ja(e) {
  const t = Tn(e), n = Jt(t, e), o = Jt(t.reverse(), e);
  return [n, o];
}
function Tn(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const a = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || a ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Jt(e, t) {
  for (const n of e)
    if (!Ua(n, { upTo: t }))
      return n;
}
function Ua(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Ka(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function he(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = Te();
    e.focus({ preventScroll: !0 }), e !== n && Ka(e) && t && e.select();
  }
}
const qa = Yo(() => O([]));
function Ya() {
  const e = qa();
  return {
    add(t) {
      const n = e.value[0];
      t !== n && (n == null || n.pause()), e.value = Gt(e.value, t), e.value.unshift(t);
    },
    remove(t) {
      var n;
      e.value = Gt(e.value, t), (n = e.value[0]) == null || n.resume();
    }
  };
}
function Gt(e, t) {
  const n = [...e], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function Xa(e) {
  return e.filter((t) => t.tagName !== "A");
}
const Ja = /* @__PURE__ */ B({
  __name: "FocusScope",
  props: {
    loop: { type: Boolean, default: !1 },
    trapped: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["mountAutoFocus", "unmountAutoFocus"],
  setup(e, { emit: t }) {
    const n = e, o = t, { currentRef: a, currentElement: l } = I(), i = O(null), s = Ya(), c = Ze({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    });
    ee((r) => {
      if (!xe)
        return;
      const u = l.value;
      if (!n.trapped)
        return;
      function f(h) {
        if (c.paused || !u)
          return;
        const b = h.target;
        u.contains(b) ? i.value = b : he(i.value, { select: !0 });
      }
      function m(h) {
        if (c.paused || !u)
          return;
        const b = h.relatedTarget;
        b !== null && (u.contains(b) || he(i.value, { select: !0 }));
      }
      function v(h) {
        u.contains(i.value) || he(u);
      }
      document.addEventListener("focusin", f), document.addEventListener("focusout", m);
      const y = new MutationObserver(v);
      u && y.observe(u, { childList: !0, subtree: !0 }), r(() => {
        document.removeEventListener("focusin", f), document.removeEventListener("focusout", m), y.disconnect();
      });
    }), ee(async (r) => {
      const u = l.value;
      if (await Pe(), !u)
        return;
      s.add(c);
      const f = Te();
      if (!u.contains(f)) {
        const m = new CustomEvent(dt, Xt);
        u.addEventListener(dt, (v) => o("mountAutoFocus", v)), u.dispatchEvent(m), m.defaultPrevented || (Ha(Xa(Tn(u)), {
          select: !0
        }), Te() === f && he(u));
      }
      r(() => {
        u.removeEventListener(dt, (y) => o("mountAutoFocus", y));
        const m = new CustomEvent(ct, Xt), v = (y) => {
          o("unmountAutoFocus", y);
        };
        u.addEventListener(ct, v), u.dispatchEvent(m), setTimeout(() => {
          m.defaultPrevented || he(f ?? document.body, { select: !0 }), u.removeEventListener(ct, v), s.remove(c);
        }, 0);
      });
    });
    function d(r) {
      if (!n.loop && !n.trapped || c.paused)
        return;
      const u = r.key === "Tab" && !r.altKey && !r.ctrlKey && !r.metaKey, f = Te();
      if (u && f) {
        const m = r.currentTarget, [v, y] = ja(m);
        v && y ? !r.shiftKey && f === y ? (r.preventDefault(), n.loop && he(v, { select: !0 })) : r.shiftKey && f === v && (r.preventDefault(), n.loop && he(y, { select: !0 })) : f === m && r.preventDefault();
      }
    }
    return (r, u) => (w(), k(p(L), {
      ref_key: "currentRef",
      ref: a,
      tabindex: "-1",
      "as-child": r.asChild,
      as: r.as,
      onKeydown: d
    }, {
      default: E(() => [
        S(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
}), [Rn, Ga] = fe("PopperRoot"), Qa = /* @__PURE__ */ B({
  inheritAttrs: !1,
  __name: "PopperRoot",
  setup(e) {
    const t = O();
    return Ga({
      anchor: t,
      onAnchorChange: (n) => t.value = n
    }), (n, o) => S(n.$slots, "default");
  }
}), Za = /* @__PURE__ */ B({
  __name: "PopperAnchor",
  props: {
    element: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = e, { forwardRef: n, currentElement: o } = I(), a = Rn();
    return ee(() => {
      a.onAnchorChange(t.element ?? o.value);
    }), (l, i) => (w(), k(p(L), {
      ref: p(n),
      as: l.as,
      "as-child": l.asChild
    }, {
      default: E(() => [
        S(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
});
function el(e) {
  return e !== null;
}
function tl(e) {
  return {
    name: "transformOrigin",
    options: e,
    fn(t) {
      var n, o, a;
      const { placement: l, rects: i, middlewareData: s } = t, c = ((n = s.arrow) == null ? void 0 : n.centerOffset) !== 0, d = c ? 0 : e.arrowWidth, r = c ? 0 : e.arrowHeight, [u, f] = yt(l), m = { start: "0%", center: "50%", end: "100%" }[f], v = (((o = s.arrow) == null ? void 0 : o.x) ?? 0) + d / 2, y = (((a = s.arrow) == null ? void 0 : a.y) ?? 0) + r / 2;
      let h = "", b = "";
      return u === "bottom" ? (h = c ? m : `${v}px`, b = `${-r}px`) : u === "top" ? (h = c ? m : `${v}px`, b = `${i.floating.height + r}px`) : u === "right" ? (h = `${-r}px`, b = c ? m : `${y}px`) : u === "left" && (h = `${i.floating.width + r}px`, b = c ? m : `${y}px`), { data: { x: h, y: b } };
    }
  };
}
function yt(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
const nl = {
  side: "bottom",
  sideOffset: 0,
  align: "center",
  alignOffset: 0,
  arrowPadding: 0,
  avoidCollisions: !0,
  collisionBoundary: () => [],
  collisionPadding: 0,
  sticky: "partial",
  hideWhenDetached: !1,
  updatePositionStrategy: "optimized",
  prioritizePosition: !1
}, [Kl, ol] = fe("PopperContent"), al = /* @__PURE__ */ B({
  inheritAttrs: !1,
  __name: "PopperContent",
  props: /* @__PURE__ */ Yn({
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  }, {
    ...nl
  }),
  emits: ["placed"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = Rn(), { forwardRef: l, currentElement: i } = I(), s = O(), c = O(), { width: d, height: r } = Pa(c), u = P(
      () => n.side + (n.align !== "center" ? `-${n.align}` : "")
    ), f = P(() => typeof n.collisionPadding == "number" ? n.collisionPadding : { top: 0, right: 0, bottom: 0, left: 0, ...n.collisionPadding }), m = P(() => Array.isArray(n.collisionBoundary) ? n.collisionBoundary : [n.collisionBoundary]), v = P(() => ({
      padding: f.value,
      boundary: m.value.filter(el),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: m.value.length > 0
    })), y = qo(() => [
      No({
        mainAxis: n.sideOffset + r.value,
        alignmentAxis: n.alignOffset
      }),
      n.prioritizePosition && n.avoidCollisions && Ut({
        ...v.value
      }),
      n.avoidCollisions && Fo({
        mainAxis: !0,
        crossAxis: !!n.prioritizePosition,
        limiter: n.sticky === "partial" ? Wo() : void 0,
        ...v.value
      }),
      !n.prioritizePosition && n.avoidCollisions && Ut({
        ...v.value
      }),
      Lo({
        ...v.value,
        apply: ({ elements: T, rects: Z, availableWidth: H, availableHeight: Y }) => {
          const { width: F, height: pe } = Z.reference, K = T.floating.style;
          K.setProperty(
            "--radix-popper-available-width",
            `${H}px`
          ), K.setProperty(
            "--radix-popper-available-height",
            `${Y}px`
          ), K.setProperty(
            "--radix-popper-anchor-width",
            `${F}px`
          ), K.setProperty(
            "--radix-popper-anchor-height",
            `${pe}px`
          );
        }
      }),
      c.value && Uo({ element: c.value, padding: n.arrowPadding }),
      tl({
        arrowWidth: d.value,
        arrowHeight: r.value
      }),
      n.hideWhenDetached && Vo({ strategy: "referenceHidden", ...v.value })
    ]), { floatingStyles: h, placement: b, isPositioned: A, middlewareData: g } = Ko(
      a.anchor,
      s,
      {
        strategy: "fixed",
        placement: u,
        whileElementsMounted: (...T) => Io(...T, {
          animationFrame: n.updatePositionStrategy === "always"
        }),
        middleware: y
      }
    ), x = P(
      () => yt(b.value)[0]
    ), C = P(
      () => yt(b.value)[1]
    );
    Xn(() => {
      A.value && o("placed");
    });
    const D = P(
      () => {
        var T;
        return ((T = g.value.arrow) == null ? void 0 : T.centerOffset) !== 0;
      }
    ), $ = O("");
    ee(() => {
      i.value && ($.value = window.getComputedStyle(i.value).zIndex);
    });
    const N = P(() => {
      var T;
      return ((T = g.value.arrow) == null ? void 0 : T.x) ?? 0;
    }), W = P(() => {
      var T;
      return ((T = g.value.arrow) == null ? void 0 : T.y) ?? 0;
    });
    return ol({
      placedSide: x,
      onArrowChange: (T) => c.value = T,
      arrowX: N,
      arrowY: W,
      shouldHideArrow: D
    }), (T, Z) => {
      var H, Y, F;
      return w(), _("div", {
        ref_key: "floatingRef",
        ref: s,
        "data-radix-popper-content-wrapper": "",
        style: ae({
          ...p(h),
          transform: p(A) ? p(h).transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: $.value,
          "--radix-popper-transform-origin": [
            (H = p(g).transformOrigin) == null ? void 0 : H.x,
            (Y = p(g).transformOrigin) == null ? void 0 : Y.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((F = p(g).hide) == null ? void 0 : F.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        })
      }, [
        R(p(L), z({ ref: p(l) }, T.$attrs, {
          "as-child": n.asChild,
          as: T.as,
          "data-side": x.value,
          "data-align": C.value,
          style: {
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: p(A) ? void 0 : "none"
          }
        }), {
          default: E(() => [
            S(T.$slots, "default")
          ]),
          _: 3
        }, 16, ["as-child", "as", "data-side", "data-align", "style"])
      ], 4);
    };
  }
}), [Mn, ql] = fe("CollectionProvider");
B({
  name: "CollectionSlot",
  setup(e, { slots: t }) {
    const n = Mn(), { primitiveElement: o, currentElement: a } = Cn();
    return U(a, () => {
      n.collectionRef.value = a.value;
    }), () => Se(Mt, { ref: o }, t);
  }
});
B({
  name: "CollectionItem",
  inheritAttrs: !1,
  props: {
    value: {
      // It accepts any value
      validator: () => !0
    }
  },
  setup(e, { slots: t, attrs: n }) {
    const o = Mn(), { primitiveElement: a, currentElement: l } = Cn();
    return ee((i) => {
      if (l.value) {
        const s = Vn(l.value);
        o.itemMap.value.set(s, { ref: l.value, value: e.value }), i(() => o.itemMap.value.delete(s));
      }
    }), () => Se(Mt, { ...n, [o.attrName]: "", ref: a }, t);
  }
});
const [Ne, ll] = fe("PaginationRoot"), il = /* @__PURE__ */ B({
  __name: "PaginationRoot",
  props: {
    page: {},
    defaultPage: { default: 1 },
    itemsPerPage: { default: 10 },
    total: { default: 0 },
    siblingCount: { default: 2 },
    disabled: { type: Boolean },
    showEdges: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: { default: "nav" }
  },
  emits: ["update:page"],
  setup(e, { emit: t }) {
    const n = e, o = t, { siblingCount: a, disabled: l, showEdges: i } = Qe(n);
    I();
    const s = Ve(n, "page", o, {
      defaultValue: n.defaultPage,
      passive: n.page === void 0
    }), c = P(() => Math.max(1, Math.ceil(n.total / n.itemsPerPage)));
    return ll({
      page: s,
      onPageChange(d) {
        s.value = d;
      },
      pageCount: c,
      siblingCount: a,
      disabled: l,
      showEdges: i
    }), (d, r) => (w(), k(p(L), {
      as: d.as,
      "as-child": d.asChild
    }, {
      default: E(() => [
        S(d.$slots, "default", {
          page: p(s),
          pageCount: c.value
        })
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
}), rl = /* @__PURE__ */ B({
  __name: "PaginationEllipsis",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = e;
    return I(), (n, o) => (w(), k(p(L), z(t, { "data-type": "ellipsis" }), {
      default: E(() => [
        S(n.$slots, "default", {}, () => [
          Q("…")
        ])
      ]),
      _: 3
    }, 16));
  }
}), sl = /* @__PURE__ */ B({
  __name: "PaginationFirst",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const t = e, n = Ne();
    I();
    const o = P(() => n.page.value === 1 || n.disabled.value);
    return (a, l) => (w(), k(p(L), z(t, {
      "aria-label": "First Page",
      type: a.as === "button" ? "button" : void 0,
      disabled: o.value,
      onClick: l[0] || (l[0] = (i) => !o.value && p(n).onPageChange(1))
    }), {
      default: E(() => [
        S(a.$slots, "default", {}, () => [
          Q("First page")
        ])
      ]),
      _: 3
    }, 16, ["type", "disabled"]));
  }
}), ul = /* @__PURE__ */ B({
  __name: "PaginationLast",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const t = e, n = Ne();
    I();
    const o = P(() => n.page.value === n.pageCount.value || n.disabled.value);
    return (a, l) => (w(), k(p(L), z(t, {
      "aria-label": "Last Page",
      type: a.as === "button" ? "button" : void 0,
      disabled: o.value,
      onClick: l[0] || (l[0] = (i) => !o.value && p(n).onPageChange(p(n).pageCount.value))
    }), {
      default: E(() => [
        S(a.$slots, "default", {}, () => [
          Q("Last page")
        ])
      ]),
      _: 3
    }, 16, ["type", "disabled"]));
  }
});
function ge(e, t) {
  const n = t - e + 1;
  return Array.from({ length: n }, (o, a) => a + e);
}
function dl(e) {
  return e.map((t) => typeof t == "number" ? { type: "page", value: t } : { type: "ellipsis" });
}
const qe = "ellipsis";
function cl(e, t, n, o) {
  const a = t, l = Math.max(e - n, 1), i = Math.min(e + n, a);
  if (o) {
    const s = Math.min(2 * n + 5, t) - 2, c = l > 3 && Math.abs(a - s - 1 + 1) > 2 && Math.abs(l - 1) > 2, d = i < a - 2 && Math.abs(a - s) > 2 && Math.abs(a - i) > 2;
    if (!c && d)
      return [...ge(1, s), qe, a];
    if (c && !d) {
      const r = ge(a - s + 1, a);
      return [1, qe, ...r];
    }
    if (c && d) {
      const r = ge(l, i);
      return [1, qe, ...r, qe, a];
    }
    return ge(1, a);
  } else {
    const s = n * 2 + 1;
    return t < s ? ge(1, a) : e <= n + 1 ? ge(1, s) : t - e <= n ? ge(t - s + 1, a) : ge(l, i);
  }
}
const fl = /* @__PURE__ */ B({
  __name: "PaginationList",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = e;
    I();
    const n = Ne(), o = P(() => dl(
      cl(
        n.page.value,
        n.pageCount.value,
        n.siblingCount.value,
        n.showEdges.value
      )
    ));
    return (a, l) => (w(), k(p(L), tn(nn(t)), {
      default: E(() => [
        S(a.$slots, "default", { items: o.value })
      ]),
      _: 3
    }, 16));
  }
}), pl = /* @__PURE__ */ B({
  __name: "PaginationListItem",
  props: {
    value: {},
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const t = e;
    I();
    const n = Ne(), o = P(() => n.page.value === t.value), a = P(() => n.disabled.value);
    return (l, i) => (w(), k(p(L), z(t, {
      "data-type": "page",
      "aria-label": `Page ${l.value}`,
      "aria-current": o.value ? "page" : void 0,
      "data-selected": o.value ? "true" : void 0,
      disabled: a.value,
      type: l.as === "button" ? "button" : void 0,
      onClick: i[0] || (i[0] = (s) => !a.value && p(n).onPageChange(l.value))
    }), {
      default: E(() => [
        S(l.$slots, "default", {}, () => [
          Q(J(l.value), 1)
        ])
      ]),
      _: 3
    }, 16, ["aria-label", "aria-current", "data-selected", "disabled", "type"]));
  }
}), ml = /* @__PURE__ */ B({
  __name: "PaginationNext",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const t = e;
    I();
    const n = Ne(), o = P(() => n.page.value === n.pageCount.value || n.disabled.value);
    return (a, l) => (w(), k(p(L), z(t, {
      "aria-label": "Next Page",
      type: a.as === "button" ? "button" : void 0,
      disabled: o.value,
      onClick: l[0] || (l[0] = (i) => !o.value && p(n).onPageChange(p(n).page.value + 1))
    }), {
      default: E(() => [
        S(a.$slots, "default", {}, () => [
          Q("Next page")
        ])
      ]),
      _: 3
    }, 16, ["type", "disabled"]));
  }
}), vl = /* @__PURE__ */ B({
  __name: "PaginationPrev",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const t = e;
    I();
    const n = Ne(), o = P(() => n.page.value === 1 || n.disabled.value);
    return (a, l) => (w(), k(p(L), z(t, {
      "aria-label": "Previous Page",
      type: a.as === "button" ? "button" : void 0,
      disabled: o.value,
      onClick: l[0] || (l[0] = (i) => !o.value && p(n).onPageChange(p(n).page.value - 1))
    }), {
      default: E(() => [
        S(a.$slots, "default", {}, () => [
          Q("Prev page")
        ])
      ]),
      _: 3
    }, 16, ["type", "disabled"]));
  }
}), [We, gl] = fe("PopoverRoot"), hl = /* @__PURE__ */ B({
  __name: "PopoverRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    modal: { type: Boolean, default: !1 }
  },
  emits: ["update:open"],
  setup(e, { emit: t }) {
    const n = e, o = t, { modal: a } = Qe(n), l = Ve(n, "open", o, {
      defaultValue: n.defaultOpen,
      passive: n.open === void 0
    }), i = O(), s = O(!1);
    return gl({
      contentId: "",
      modal: a,
      open: l,
      onOpenChange: (c) => {
        l.value = c;
      },
      onOpenToggle: () => {
        l.value = !l.value;
      },
      triggerElement: i,
      hasCustomAnchor: s
    }), (c, d) => (w(), k(p(Qa), null, {
      default: E(() => [
        S(c.$slots, "default", { open: p(l) })
      ]),
      _: 3
    }));
  }
}), yl = /* @__PURE__ */ B({
  __name: "PopoverTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const t = e, n = We(), { forwardRef: o, currentElement: a } = I();
    return Me(() => {
      n.triggerElement.value = a.value;
    }), (l, i) => (w(), k(zn(p(n).hasCustomAnchor.value ? p(L) : p(Za)), { "as-child": "" }, {
      default: E(() => [
        R(p(L), {
          ref: p(o),
          type: l.as === "button" ? "button" : void 0,
          "aria-haspopup": "dialog",
          "aria-expanded": p(n).open.value,
          "aria-controls": p(n).contentId,
          "data-state": p(n).open.value ? "open" : "closed",
          as: l.as,
          "as-child": t.asChild,
          onClick: p(n).onOpenToggle
        }, {
          default: E(() => [
            S(l.$slots, "default")
          ]),
          _: 3
        }, 8, ["type", "aria-expanded", "aria-controls", "data-state", "as", "as-child", "onClick"])
      ]),
      _: 3
    }));
  }
}), bl = /* @__PURE__ */ B({
  __name: "PopoverPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(e) {
    const t = e;
    return (n, o) => (w(), k(p(Na), tn(nn(t)), {
      default: E(() => [
        S(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), _n = /* @__PURE__ */ B({
  __name: "PopoverContentImpl",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = wn(n), { forwardRef: l } = I(), i = We();
    return ya(), (s, c) => (w(), k(p(Ja), {
      "as-child": "",
      loop: "",
      trapped: s.trapFocus,
      onMountAutoFocus: c[5] || (c[5] = (d) => o("openAutoFocus", d)),
      onUnmountAutoFocus: c[6] || (c[6] = (d) => o("closeAutoFocus", d))
    }, {
      default: E(() => [
        R(p(Wa), {
          "as-child": "",
          "disable-outside-pointer-events": s.disableOutsidePointerEvents,
          onPointerDownOutside: c[0] || (c[0] = (d) => o("pointerDownOutside", d)),
          onInteractOutside: c[1] || (c[1] = (d) => o("interactOutside", d)),
          onEscapeKeyDown: c[2] || (c[2] = (d) => o("escapeKeyDown", d)),
          onFocusOutside: c[3] || (c[3] = (d) => o("focusOutside", d)),
          onDismiss: c[4] || (c[4] = (d) => p(i).onOpenChange(!1))
        }, {
          default: E(() => [
            R(p(al), z(p(a), {
              id: p(i).contentId,
              ref: p(l),
              "data-state": p(i).open.value ? "open" : "closed",
              role: "dialog",
              style: {
                "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
              }
            }), {
              default: E(() => [
                S(s.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "data-state"])
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), wl = /* @__PURE__ */ B({
  __name: "PopoverContentModal",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = We(), l = O(!1);
    ma(!0);
    const i = Tt(n, o), { forwardRef: s, currentElement: c } = I();
    return Aa(c), (d, r) => (w(), k(_n, z(p(i), {
      ref: p(s),
      "trap-focus": p(a).open.value,
      "disable-outside-pointer-events": "",
      onCloseAutoFocus: r[0] || (r[0] = Nt(
        (u) => {
          var f;
          o("closeAutoFocus", u), l.value || (f = p(a).triggerElement.value) == null || f.focus();
        },
        ["prevent"]
      )),
      onPointerDownOutside: r[1] || (r[1] = (u) => {
        o("pointerDownOutside", u);
        const f = u.detail.originalEvent, m = f.button === 0 && f.ctrlKey === !0, v = f.button === 2 || m;
        l.value = v;
      }),
      onFocusOutside: r[2] || (r[2] = Nt(() => {
      }, ["prevent"]))
    }), {
      default: E(() => [
        S(d.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus"]));
  }
}), xl = /* @__PURE__ */ B({
  __name: "PopoverContentNonModal",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = We(), l = O(!1), i = O(!1), s = Tt(n, o);
    return (c, d) => (w(), k(_n, z(p(s), {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      onCloseAutoFocus: d[0] || (d[0] = (r) => {
        var u;
        o("closeAutoFocus", r), r.defaultPrevented || (l.value || (u = p(a).triggerElement.value) == null || u.focus(), r.preventDefault()), l.value = !1, i.value = !1;
      }),
      onInteractOutside: d[1] || (d[1] = async (r) => {
        var u;
        o("interactOutside", r), r.defaultPrevented || (l.value = !0, r.detail.originalEvent.type === "pointerdown" && (i.value = !0));
        const f = r.target;
        (u = p(a).triggerElement.value) != null && u.contains(f) && r.preventDefault(), r.detail.originalEvent.type === "focusin" && i.value && r.preventDefault();
      })
    }), {
      default: E(() => [
        S(c.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Cl = /* @__PURE__ */ B({
  __name: "PopoverContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = We(), l = Tt(n, o), { forwardRef: i } = I();
    return a.contentId || (a.contentId = Rt(void 0, "radix-vue-popover-content")), (s, c) => (w(), k(p(En), {
      present: s.forceMount || p(a).open.value
    }, {
      default: E(() => [
        p(a).modal.value ? (w(), k(wl, z({ key: 0 }, p(l), { ref: p(i) }), {
          default: E(() => [
            S(s.$slots, "default")
          ]),
          _: 3
        }, 16)) : (w(), k(xl, z({ key: 1 }, p(l), { ref: p(i) }), {
          default: E(() => [
            S(s.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
});
function Al() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
Al();
const V = /* @__PURE__ */ B({
  __name: "Icon.component",
  props: {
    name: {},
    type: { default: "fad" },
    color: { default: "primary" },
    size: { default: "1" }
  },
  setup(e) {
    return (t, n) => (w(), _("i", {
      class: M(`${t.type} fa-${t.name} ex-text-${t.color}`),
      "data-testid": "extracadabra-icon",
      style: ae(`font-size: ${t.size}em`)
    }, null, 6));
  }
}), El = { class: "ex-accordion-content-text" }, Yl = /* @__PURE__ */ B({
  __name: "ExAccordion.component",
  props: {
    borderRadius: { default: "md" },
    backgroundColor: { default: "primary-50" },
    headerColor: { default: "primary" },
    headerTextColor: { default: "primary-50" },
    contentTextColor: { default: "primary" },
    itemId: { default: "" },
    openedItemId: { default: "" }
  },
  emits: ["updateState"],
  setup(e, { emit: t }) {
    const n = t, o = O(!1);
    U(
      () => e.openedItemId,
      async (i) => {
        o.value = i === e.itemId;
      }
    );
    const a = function() {
      return o.value ? "chevron-up" : "chevron-down";
    }, l = function() {
      o.value = !o.value, n("updateState", (o.value, e.itemId));
    };
    return (i, s) => (w(), k(p(On), {
      class: M(["ex-accordion-root", `bg-${i.backgroundColor} ex-accordion-border-${i.borderRadius}`]),
      type: "single",
      collapsible: !0,
      "data-testid": "extracadabra-accordion",
      "onUpdate:modelValue": l
    }, {
      default: E(() => [
        R(p($n), {
          class: M(["ex-accordion-item", `ex-accordion-border-${i.borderRadius}`]),
          value: "header",
          open: o.value
        }, {
          default: E(() => [
            R(p(Bn), {
              class: M(["ex-accordion-header", `ex-bg-${i.headerColor} ex-text-${i.headerTextColor}`])
            }, {
              default: E(() => [
                R(p(Sn), {
                  class: M(["ex-accordion-trigger", `ex-bg-${i.headerColor} ex-text-${i.headerTextColor}`])
                }, {
                  default: E(() => [
                    S(i.$slots, "headerContent"),
                    R(V, {
                      name: a(),
                      type: "fas",
                      color: i.headerTextColor,
                      size: "1.2"
                    }, null, 8, ["name", "color"])
                  ]),
                  _: 3
                }, 8, ["class"])
              ]),
              _: 3
            }, 8, ["class"]),
            R(p(kn), {
              class: M(["ex-accordion-content", `ex-text-${i.contentTextColor}`])
            }, {
              default: E(() => [
                q("div", El, [
                  S(i.$slots, "content")
                ])
              ]),
              _: 3
            }, 8, ["class"])
          ]),
          _: 3
        }, 8, ["class", "open"])
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Pl = { class: "ex-accordion-content-text" }, Xl = /* @__PURE__ */ B({
  __name: "ExAccordionMultiple.component",
  props: {
    borderRadius: { default: "md" },
    items: { default: () => [] },
    backgroundColor: { default: "primary-50" },
    headerColor: { default: "primary" },
    headerTextColor: { default: "primary-50" },
    contentTextColor: { default: "primary" }
  },
  emits: ["updateState"],
  setup(e, { emit: t }) {
    const n = t, o = Ze({
      openedItem: null
    }), a = function(i) {
      return o.openedItem && o.openedItem === i ? "chevron-up" : "chevron-down";
    }, l = function(i) {
      Array.isArray(i) ? o.openedItem = i[0] || null : o.openedItem = i, n("updateState", o.openedItem);
    };
    return (i, s) => (w(), k(p(On), {
      class: M(["ex-accordion-multiple-root", `bg-${i.backgroundColor} ex-accordion-border-${i.borderRadius}`]),
      "default-value": "'item-1'",
      type: "single",
      collapsible: !0,
      "data-testid": "extracadabra-accordion",
      "onUpdate:modelValue": l
    }, {
      default: E(() => [
        (w(!0), _(ue, null, Ce(i.items, (c) => (w(), k(p($n), {
          key: c.value,
          class: M(["ex-accordion-item", `ex-accordion-border-${i.borderRadius}`]),
          value: c.value
        }, {
          default: E(() => [
            R(p(Bn), {
              class: M(["ex-accordion-header", `ex-bg-${i.headerColor} ex-text-${i.headerTextColor}`])
            }, {
              default: E(() => [
                R(p(Sn), {
                  class: M(["ex-accordion-trigger", `ex-bg-${i.headerColor} ex-text-${i.headerTextColor}`])
                }, {
                  default: E(() => [
                    q("span", null, J(c.title), 1),
                    R(V, {
                      name: a(c.value),
                      type: "fas",
                      color: i.headerTextColor,
                      size: "1.2"
                    }, null, 8, ["name", "color"])
                  ]),
                  _: 2
                }, 1032, ["class"])
              ]),
              _: 2
            }, 1032, ["class"]),
            R(p(kn), {
              class: M(["ex-accordion-content", `ex-text-${i.contentTextColor}`])
            }, {
              default: E(() => [
                q("div", Pl, J(c.content), 1)
              ]),
              _: 2
            }, 1032, ["class"])
          ]),
          _: 2
        }, 1032, ["class", "value"]))), 128))
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Ol = {
  class: "ex-animated-menu",
  "data-testid": "extracadabra-menu"
}, $l = ["onClick"], kl = { class: "ex-animated-menu-content ex-text-primary-700" }, Bl = { class: "ex-animated-menu-state" }, Jl = /* @__PURE__ */ B({
  __name: "ExAnimatedMenu.component",
  props: {
    iconColor: { default: "white-600" },
    iconBackground: { default: "primary-700" },
    color: { default: "primary-500" },
    background: { default: "primary-500" },
    items: { default: () => [] },
    activeItem: { default: null }
  },
  emits: ["action"],
  setup(e, { emit: t }) {
    const n = t, o = function(a = null) {
      const l = a !== null ? e.items[a] : null;
      n("action", l);
    };
    return (a, l) => (w(), _("div", Ol, [
      (w(!0), _(ue, null, Ce(a.items, (i, s) => (w(), k(Gn, {
        key: s,
        "enter-active-class": "animated fadeInDown",
        "leave-active-class": "animated fadeOutUp"
      }, {
        default: E(() => [
          !a.activeItem || a.activeItem && a.activeItem.label === a.items[s].label ? (w(), _("div", z({
            key: 0,
            ref_for: !0
          }, a.$attrs, {
            class: [
              "ex-animated-menu-item",
              `ex-text-${a.color}`,
              `ex-bg-${a.background}`,
              a.$attrs.class
            ],
            onClick: (c) => o(a.activeItem !== null ? null : s)
          }), [
            q("section", {
              class: M(["ex-animated-menu-icon", `ex-bg-${a.iconBackground}`])
            }, [
              R(V, {
                name: i.icon,
                color: a.iconColor,
                type: "fas",
                size: "1.4"
              }, null, 8, ["name", "color"])
            ], 2),
            q("section", kl, [
              q("div", null, J(i.label), 1)
            ]),
            q("section", Bl, [
              R(V, {
                name: a.activeItem !== null ? "minus" : "plus",
                color: "primary-700",
                type: "fas"
              }, null, 8, ["name"])
            ])
          ], 16, $l)) : j("", !0)
        ]),
        _: 2
      }, 1024))), 128))
    ]));
  }
}), Sl = /* @__PURE__ */ B({
  __name: "ExButton.component",
  props: {
    label: {},
    icon: { default: "" },
    variant: { default: "filled" },
    textColor: { default: "white" },
    backgroundColor: { default: "" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = (a) => {
      o("click", a);
    }, o = t;
    return (a, l) => (w(), _("button", {
      class: M(["ex-button", [`ex-text-${a.textColor}`, `ex-bg-${a.backgroundColor}`, `ex-button--${a.variant}`]]),
      onClick: n
    }, [
      Q(J(a.label) + " ", 1),
      a.icon ? (w(), k(p(V), {
        key: 0,
        name: a.icon,
        color: a.textColor
      }, null, 8, ["name", "color"])) : j("", !0)
    ], 2));
  }
}), at = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, a] of t)
    n[o] = a;
  return n;
}, Gl = /* @__PURE__ */ at(Sl, [["__scopeId", "data-v-49281b1a"]]), Dl = {
  __name: "ExScrollToTopBtn.component",
  props: {
    visibilityHeight: {
      type: Number,
      default: 300
    },
    scrollDuration: {
      type: Number,
      default: 500
    },
    bgColor: {
      type: String,
      default: "#072C55"
    },
    iconColor: {
      type: String,
      default: "#FFFFFF"
    }
  },
  setup(e) {
    const t = e, n = O(!1), o = () => {
      n.value = window.scrollY > t.visibilityHeight;
    }, a = () => {
      const l = window.scrollY, i = performance.now(), s = (c) => {
        const d = c - i, r = Math.min(d / t.scrollDuration, 1), u = (f) => 1 - Math.pow(1 - f, 3);
        window.scrollTo(0, l * (1 - u(r))), r < 1 && window.requestAnimationFrame(s);
      };
      window.requestAnimationFrame(s);
    };
    return Me(() => {
      window.addEventListener("scroll", o);
    }), bt(() => {
      window.removeEventListener("scroll", o);
    }), (l, i) => Ye((w(), _("button", {
      class: "scroll-to-top-btn",
      style: ae(`background-color: ${e.bgColor}`),
      onClick: a
    }, [
      R(p(V), {
        name: "fa-solid fa-chevron-up",
        class: "icon",
        color: e.iconColor
      }, null, 8, ["color"])
    ], 4)), [
      [ft, n.value]
    ]);
  }
}, Ql = /* @__PURE__ */ at(Dl, [["__scopeId", "data-v-a89836dd"]]), Tl = /* @__PURE__ */ B({
  __name: "ExPagination.component",
  props: {
    defaultPage: {},
    total: {},
    itemsPerPage: {},
    siblingCount: { default: 5 },
    showFirstLastButtons: { type: Boolean, default: !0 },
    showPrevNextButtons: { type: Boolean, default: !0 },
    color: { default: "primary" },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" }
  },
  emits: ["update:page"],
  setup(e, { emit: t }) {
    const n = e, o = O(n.defaultPage), a = t, l = P(() => {
      switch (n.size) {
        case "sm":
          return "width: 1.5rem; height: 1.5rem; font-size: 0.8rem;";
        case "lg":
          return "width: 3rem; height: 3rem; font-size: 1.2em;";
        default:
          return "width: 2rem; height: 2rem; font-size: 1rem;";
      }
    }), i = P(() => `bg-${n.color} text-white pagination-button--shadow`), s = P(() => n.disabled), c = (r) => r === o.value ? `bg-${n.color} text-white` : "", d = (r) => {
      s.value || a("update:page", r);
    };
    return (r, u) => (w(), k(p(il), {
      page: o.value,
      "onUpdate:page": [
        u[0] || (u[0] = (f) => o.value = f),
        d
      ],
      total: r.total,
      "items-per-page": r.itemsPerPage,
      "sibling-count": r.siblingCount,
      "show-edges": "",
      class: M(`text-${r.color}`)
    }, {
      default: E(() => [
        R(p(fl), { class: "ex-pagination" }, {
          default: E(({ items: f }) => [
            r.showFirstLastButtons ? (w(), k(p(sl), {
              key: 0,
              disabled: o.value === 1 || r.disabled,
              class: M(["ex-pagination-button", [{ "ex-pagination-button--disabled": o.value === 1 || r.disabled }]]),
              style: ae([{ backgroundColor: "transparent" }, l.value]),
              "aria-label": "First page"
            }, {
              default: E(() => [
                R(p(V), {
                  name: "angles-left",
                  type: "fas",
                  size: r.size === "sm" ? "0.8" : r.size === "lg" ? "1.2" : "1",
                  color: r.color
                }, null, 8, ["size", "color"])
              ]),
              _: 1
            }, 8, ["disabled", "class", "style"])) : j("", !0),
            r.showPrevNextButtons ? (w(), k(p(vl), {
              key: 1,
              disabled: o.value === 1 || r.disabled,
              class: M(["ex-pagination-button", [{ "pagination-button--disabled": o.value === 1 || r.disabled }]]),
              style: ae([{ backgroundColor: "transparent" }, l.value]),
              "aria-label": "Previous page"
            }, {
              default: E(() => [
                R(p(V), {
                  name: "angle-left",
                  type: "fas",
                  size: r.size === "sm" ? "0.8" : r.size === "lg" ? "1.2" : "1",
                  color: r.color
                }, null, 8, ["size", "color"])
              ]),
              _: 1
            }, 8, ["disabled", "class", "style"])) : j("", !0),
            (w(!0), _(ue, null, Ce(f, (m, v) => (w(), _(ue, null, [
              m.type === "page" ? (w(), k(p(pl), {
                key: v,
                value: m.value,
                class: M(["ex-pagination-button", [
                  { [i.value]: o.value === m.value },
                  c(m.value)
                ]]),
                style: ae([
                  { backgroundColor: o.value !== m.value ? "transparent" : "" },
                  l.value
                ])
              }, {
                default: E(() => [
                  Q(J(m.value), 1)
                ]),
                _: 2
              }, 1032, ["value", "class", "style"])) : (w(), k(p(rl), {
                key: m.type,
                index: v,
                class: "ex-pagination-ellipsis"
              }, {
                default: E(() => u[1] || (u[1] = [
                  Q(" … ")
                ])),
                _: 2
              }, 1032, ["index"]))
            ], 64))), 256)),
            r.showPrevNextButtons ? (w(), k(p(ml), {
              key: 2,
              disabled: o.value === r.total || r.disabled,
              class: M(["ex-pagination-button", [{ "pagination-button--disabled": o.value === r.total || r.disabled }]]),
              style: ae([{ backgroundColor: "transparent" }, l.value]),
              "aria-label": "Next page"
            }, {
              default: E(() => [
                R(p(V), {
                  name: "angle-right",
                  type: "fas",
                  size: r.size === "sm" ? "0.8" : r.size === "lg" ? "1.2" : "1",
                  color: r.color
                }, null, 8, ["size", "color"])
              ]),
              _: 1
            }, 8, ["disabled", "class", "style"])) : j("", !0),
            r.showFirstLastButtons ? (w(), k(p(ul), {
              key: 3,
              disabled: o.value === r.total || r.disabled,
              class: M(["ex-pagination-button", [{ "pagination-button--disabled": o.value === r.total || r.disabled }]]),
              style: ae([{ backgroundColor: "transparent" }, l.value]),
              "aria-label": "Last page"
            }, {
              default: E(() => [
                R(p(V), {
                  name: "angles-right",
                  type: "fas",
                  size: r.size === "sm" ? "0.8" : r.size === "lg" ? "1.2" : "1",
                  color: r.color
                }, null, 8, ["size", "color"])
              ]),
              _: 1
            }, 8, ["disabled", "class", "style"])) : j("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["page", "total", "items-per-page", "sibling-count", "class"]));
  }
}), Zl = /* @__PURE__ */ at(Tl, [["__scopeId", "data-v-40a4d945"]]), Rl = (e, t) => e.some((n) => n === t), Ml = (e, t) => [...e, t], _l = (e, t) => e.filter((n) => n !== t), Il = (e, t) => Rl(e, t) ? _l(e, t) : Ml(e, t), Nl = { key: 1 }, Fl = ["onClick"], Ll = { class: "popover--menu--label" }, Vl = ["onClick"], ei = /* @__PURE__ */ B({
  __name: "Popover.component",
  props: /* @__PURE__ */ Ft({
    label: {},
    items: {},
    direction: { default: "column" },
    icon: {},
    grouped: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    textColor: { default: "secondary" },
    borderColor: { default: "secondary" },
    backgroundColor: { default: "white" },
    useInput: { type: Boolean, default: !1 }
  }, {
    value: {},
    valueModifiers: {}
  }),
  emits: /* @__PURE__ */ Ft(["action"], ["update:value"]),
  setup(e, { emit: t }) {
    const n = Ze({
      input: ""
    }), o = Qn(e, "value"), a = O("auto"), l = O(null), i = () => {
      var g;
      if ((g = l.value) != null && g.$el) {
        const { top: x, bottom: C } = l.value.$el.getBoundingClientRect(), D = window.innerHeight, $ = x > D / 2 ? x - 50 : D - x - (C - x) - 50;
        a.value = `${$}px`;
      }
    }, s = (g) => {
      m.value = g, g ? setTimeout(i, 0) : c();
    }, c = () => {
      n.input = "";
    }, d = P(() => {
      let g = null;
      return n.input || (g = e.items), !e.grouped && v(e.items) ? g = e.items.filter((x) => r(x.label).includes(n.input)) : e.grouped && y(e.items) && (g = e.items.map((x) => ({
        ...x,
        options: x.options.filter(
          (C) => r(C.label).includes(n.input)
        )
      }))), g;
    }), r = (g) => g.normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "").toLowerCase(), u = t, f = O(o.value || []), m = O(!1), v = (g) => Array.isArray(g), y = (g) => Array.isArray(g) && "label" in g[0] && "options" in g[0], h = (g) => {
      e.multiple && Array.isArray(f.value) ? f.value = Il(f.value, g) : f.value = g, A(e.multiple) && (m.value = !1), u("action", f.value);
    }, b = (g) => Array.isArray(f.value) ? f.value.some((x) => x === g) : f.value === g, A = (g) => !g;
    return (g, x) => (w(), k(p(hl), z({ class: "popover" }, g.$attrs, {
      open: m.value,
      "onUpdate:open": s
    }), {
      default: E(() => [
        R(p(yl), {
          ref_key: "popoverTriggerRef",
          ref: l,
          class: M(["popover--button", `ex-text-${g.textColor} ex-border-${g.borderColor} ex-bg-${g.backgroundColor}`])
        }, {
          default: E(() => [
            g.multiple && f.value.length ? (w(), _("span", {
              key: 0,
              class: M(`ex-bg-${g.borderColor} popover--button--badge`)
            }, J(f.value.length), 3)) : j("", !0),
            Q(" " + J(g.label) + " ", 1),
            R(p(V), {
              name: g.icon,
              color: g.textColor
            }, null, 8, ["name", "color"])
          ]),
          _: 1
        }, 8, ["class"]),
        R(p(bl), null, {
          default: E(() => [
            R(p(Cl), {
              align: "end",
              "side-offset": 3,
              "avoid-collision": "",
              sticky: "always",
              class: "popover--content",
              style: ae({ maxHeight: a.value })
            }, {
              default: E(() => [
                g.useInput ? (w(), _("section", {
                  key: 0,
                  class: M(["popover--content--filter", `popover--menu-${g.direction}`])
                }, [
                  Ye(q("input", {
                    "onUpdate:modelValue": x[0] || (x[0] = (C) => n.input = C),
                    type: "text",
                    class: "popover--menu--input bg-dark-50",
                    placeholder: "Rechercher..."
                  }, null, 512), [
                    [Zn, n.input]
                  ]),
                  Ye(R(p(V), {
                    name: "xmark",
                    color: "dark-500",
                    onClick: c
                  }, null, 512), [
                    [ft, n.input]
                  ])
                ], 2)) : j("", !0),
                !g.grouped && v(g.items) ? (w(), _("section", Nl, [
                  (w(!0), _(ue, null, Ce(d.value, (C, D) => (w(), _("div", {
                    key: D,
                    class: "popover--menu--item",
                    onClick: ($) => h(C.value)
                  }, [
                    q("span", {
                      class: M({ "popover--menu--item_selected": b(C.value) })
                    }, J(C.label), 3)
                  ], 8, Fl))), 128))
                ])) : j("", !0),
                g.grouped && y(g.items) ? (w(), _("section", {
                  key: 2,
                  class: M(["popover--menu", `popover--menu-${g.direction}`])
                }, [
                  (w(!0), _(ue, null, Ce(d.value, (C, D) => (w(), _("div", { key: D }, [
                    q("p", Ll, J(C.label), 1),
                    "options" in C && C.options.length ? (w(!0), _(ue, { key: 0 }, Ce(C.options, ($) => (w(), _("div", {
                      key: $.value,
                      class: "popover--menu--item",
                      onClick: (N) => h($.value)
                    }, [
                      q("span", {
                        class: M({ "popover--menu--item_selected": !g.multiple && b($.value) })
                      }, J($.label), 3),
                      Ye(R(p(V), {
                        name: "check",
                        color: g.textColor
                      }, null, 8, ["color"]), [
                        [ft, g.multiple && b($.value)]
                      ])
                    ], 8, Vl))), 128)) : j("", !0)
                  ]))), 128))
                ], 2)) : j("", !0)
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16, ["open"]));
  }
}), zl = ["onClick"], Wl = {
  key: 0,
  class: "ex-animated-menu-item-2--content"
}, ti = /* @__PURE__ */ B({
  __name: "ExAnimatedMenu2.component",
  props: {
    menu: {},
    defaultMenuCode: {},
    textColor: { default: "primary-700" },
    backgroundColor: { default: "white" },
    iconBackground: { default: "primary" },
    iconColor: { default: "white" }
  },
  setup(e) {
    eo((d) => ({
      "577da04f": n.value
    }));
    const t = O(null), n = O(""), o = O([]), a = O(null), l = (d) => {
      t.value = d !== null ? e.menu[d] : null;
    }, i = (d) => {
      if (a.value) {
        const { top: r } = a.value.getBoundingClientRect(), { top: u } = o.value[d].getBoundingClientRect(), f = r - u;
        n.value = `${f}px`;
      }
    }, s = (d) => t.value && t.value.code === d.code, c = (d) => t.value && t.value.code !== d.code;
    return Me(() => {
      if (e.defaultMenuCode) {
        const d = e.menu.findIndex((r) => e.defaultMenuCode === r.code);
        l(d), i(d);
      }
    }), (d, r) => (w(), _("div", {
      ref_key: "menuParent",
      ref: a,
      class: "ex-animate-menu-2"
    }, [
      (w(!0), _(ue, null, Ce(d.menu, (u, f) => (w(), _("div", {
        ref_for: !0,
        ref: (m) => {
          o.value.push(m);
        },
        key: f,
        class: M(["ex-animated-menu-item-2", [
          {
            unselected: c(u),
            selected: s(u)
          },
          d.$attrs.class
        ]])
      }, [
        q("section", {
          class: "ex-animated-menu-item-2--header",
          onClick: () => {
            l(t.value !== null ? null : f), i(f);
          }
        }, [
          q("div", {
            class: M(["ex-animated-menu-item-2--icon", `bg-${d.iconBackground}`])
          }, [
            R(V, {
              name: u.icon,
              color: d.iconColor
            }, null, 8, ["name", "color"])
          ], 2),
          q("div", {
            class: M(["ex-animated-menu-item-2--label", `text-${d.textColor} bg-${d.backgroundColor}`])
          }, [
            Q(J(u.label) + " ", 1),
            R(V, {
              name: s(u) ? "minus" : "plus",
              color: d.textColor
            }, null, 8, ["name", "color"])
          ], 2)
        ], 8, zl),
        s(u) ? (w(), _("section", Wl, [
          S(d.$slots, u.code)
        ])) : j("", !0)
      ], 2))), 128))
    ], 512));
  }
}), Hl = /* @__PURE__ */ B({
  __name: "ExChip.component",
  props: {
    label: {},
    color: { default: "primary" },
    iconName: { default: "" }
  },
  setup(e) {
    return (t, n) => (w(), _("span", {
      class: M(["ex-chip", [
        `ex-bg-${t.color}-100 ex-text-${t.color}`,
        t.label ? "" : "ex-chip-icon",
        t.iconName ? "" : "ex-chip-label"
      ]])
    }, [
      t.iconName ? (w(), k(p(V), {
        key: 0,
        color: t.color,
        name: t.iconName,
        type: "fas",
        size: "16px"
      }, null, 8, ["color", "name"])) : j("", !0),
      Q(" " + J(t.label), 1)
    ], 2));
  }
}), ni = /* @__PURE__ */ at(Hl, [["__scopeId", "data-v-50085420"]]);
export {
  Yl as ExAccordion,
  Xl as ExAccordionMultiple,
  Jl as ExAnimatedMenu,
  ti as ExAnimatedMenuV2,
  Gl as ExButton,
  ni as ExChip,
  Zl as ExPagination,
  Ql as ExScrollToTopBtn,
  V as Icon,
  ei as Popover
};
